var _polygon, _polygon2, _polygon3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientRegister(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-22",
    cx: 250,
    cy: 367.14,
    rx: 240.24,
    ry: 118.75,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-22",
    d: "M284.3,273.64c11.47,6.62,11.47,17.36,0,24s-30.07,6.62-41.54,0-11.47-17.36,0-24S272.83,267,284.3,273.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-22",
    d: "M200,284.38,28,383.8a1.35,1.35,0,0,0,0,2.55l49.21,28.39a4.85,4.85,0,0,0,4.42,0l172-99.42a1.35,1.35,0,0,0,0-2.55l-49.21-28.39A4.91,4.91,0,0,0,200,284.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-22",
    cx: 184.08,
    cy: 420.1,
    rx: 52.32,
    ry: 30.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-22",
    points: "342.5 448.24 464.37 377.88 383.12 330.98 261.26 401.33 342.5 448.24",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Curtains--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--curtains--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.57,44.73v258.6l-12.4-7.15V53.53c0-1,1.86-2.73,4.77-4.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,310.62l-25-14.44V53.53a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,310.62l-25-14.44V53.53a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,53.47c-2,.7-3.58,1-4.25.58a.57.57,0,0,1-.31-.52V296.18l4.57,2.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.86,44.67c-1.12-.65-4.94.5-8.53,2.57l-1.62.94V304.57l10.48,6.05V45.22A.6.6,0,0,0,331.86,44.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.19,53.42a.62.62,0,0,0-.33-.55c-1.12-.64-4.94.51-8.53,2.58L316,59.68c-3.58,2.07-7.4,3.22-8.52,2.57a.56.56,0,0,1-.31-.51V53.53a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.59.59,0,0,1,.33.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.8,49.36l-.11,0-7.62,4.4c-2.91,1.68-4.77,3.45-4.77,4.41V300.87l4.56,2.63h0l12.34,7.12V45.23C332.24,46.15,330.53,47.78,327.8,49.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,315.31l-25-14.44V58.22a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,315.31l-25-14.44V58.22a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.86,58.16c-2,.7-3.59,1-4.25.58a.57.57,0,0,1-.31-.52V300.87l4.57,2.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,49.36c-1.12-.65-4.94.5-8.53,2.57l-1.63.94V309.26l10.49,6.05V49.91A.6.6,0,0,0,340,49.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.31,58.11a.62.62,0,0,0-.33-.55c-1.13-.65-4.94.51-8.53,2.58l-7.32,4.22c-3.59,2.07-7.4,3.23-8.53,2.58a.57.57,0,0,1-.31-.52v-8.2a.57.57,0,0,0,.31.51c1.13.65,4.94-.5,8.53-2.57l7.32-4.23c3.59-2.07,7.4-3.23,8.53-2.58a.62.62,0,0,1,.33.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,54.07l-.12,0-7.61,4.4c-2.91,1.68-4.77,3.45-4.77,4.41V305.58l4.56,2.63h0l12.34,7.11V49.94C340.4,50.86,338.69,52.49,336,54.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.47,320l-25-14.44V62.93a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.47,320l-25-14.44V62.93a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,62.87c-1.95.7-3.58,1-4.24.58a.57.57,0,0,1-.31-.52V305.58l4.56,2.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.14,54.07c-1.12-.65-4.94.5-8.53,2.57l-1.63.94V314l10.49,6V54.62A.6.6,0,0,0,348.14,54.07Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.47,62.82a.62.62,0,0,0-.33-.55c-1.13-.65-4.94.51-8.53,2.58l-7.32,4.22c-3.59,2.08-7.41,3.23-8.53,2.58a.57.57,0,0,1-.31-.52v-8.2a.56.56,0,0,0,.31.51c1.12.65,4.94-.5,8.53-2.57l7.32-4.23c3.59-2.07,7.4-3.23,8.53-2.58a.62.62,0,0,1,.33.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.12,58.78l-.12,0-7.62,4.4c-2.91,1.68-4.77,3.45-4.77,4.41V310.29l4.57,2.63h0L348.51,320V54.65C348.56,55.57,346.85,57.2,344.12,58.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,324.73l-25-14.44V67.64a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,324.73l-25-14.44V67.64a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58l7.32-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.17,67.58c-1.95.7-3.58,1-4.25.58a.57.57,0,0,1-.31-.52V310.29l4.57,2.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.29,58.78c-1.12-.65-4.94.5-8.53,2.57l-1.62.94V318.68l10.48,6.05V59.33A.6.6,0,0,0,356.29,58.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.63,67.53a.63.63,0,0,0-.34-.55c-1.12-.65-4.93.51-8.52,2.58l-7.32,4.23c-3.59,2.07-7.41,3.22-8.53,2.57a.57.57,0,0,1-.31-.51V67.64a.56.56,0,0,0,.31.51c1.12.65,4.94-.5,8.53-2.57l7.32-4.23c3.59-2.07,7.4-3.22,8.52-2.58a.63.63,0,0,1,.34.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.28,63.49l-.12,0-7.62,4.4c-2.91,1.68-4.77,3.45-4.77,4.41V315l4.57,2.63h0l12.34,7.11V59.36C356.72,60.28,355,61.91,352.28,63.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,64v258.4c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1-6.38-3.68L339.76,315V72.35a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58L354.3,67l1.62-.94c3.59-2.07,7.41-3.22,8.53-2.57A.6.6,0,0,1,364.78,64Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,64v258.4c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1-6.38-3.68L339.76,315V72.35a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.52-2.58L354.3,67l1.62-.94c3.59-2.07,7.41-3.22,8.53-2.57A.6.6,0,0,1,364.78,64Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.33,72.29c-2,.7-3.58,1-4.25.58a.57.57,0,0,1-.31-.52V315l4.57,2.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,64v258.4c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1V67l1.62-.94c3.59-2.07,7.41-3.22,8.53-2.57A.6.6,0,0,1,364.78,64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,72.24a.6.6,0,0,0-.33-.55c-1.12-.65-4.94.51-8.52,2.58l-7.32,4.23c-3.59,2.07-7.41,3.22-8.53,2.57a.56.56,0,0,1-.31-.51V72.35a.56.56,0,0,0,.31.51c1.12.65,4.94-.5,8.53-2.57l7.32-4.23c3.58-2.07,7.4-3.22,8.52-2.58a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.83,64.11v258.3l-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1-6.38-3.68V77.06c0-1,1.86-2.73,4.77-4.41l1.6-.92,6-3.48.11,0c2.45-1.41,4.07-2.86,4.35-3.81A1,1,0,0,0,364.83,64.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,68.75v249l-.7.39-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1-6.38-3.68V77.06a.57.57,0,0,0,.31.52c.86.49,3.33-.08,6.06-1.32A27.29,27.29,0,0,0,356.76,75l5.7-3.29,1.62-.94.7-.39.05,0,.35-.18.51-.26c.55-.27,1.09-.52,1.61-.73l.48-.2.07,0c.27-.1.54-.2.8-.28l.21-.07.44-.14.66-.18.67-.15a3.25,3.25,0,0,1,2,.07A.6.6,0,0,1,372.94,68.75Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,68.75v249l-.7.39-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0l-1.78-1-6.38-3.68V77.06a.57.57,0,0,0,.31.52c.86.49,3.33-.08,6.06-1.32A27.29,27.29,0,0,0,356.76,75l5.7-3.29,1.62-.94.7-.39.05,0,.35-.18.51-.26c.55-.27,1.09-.52,1.61-.73l.48-.2.07,0c.27-.1.54-.2.8-.28l.21-.07.44-.14.66-.18.67-.15a3.25,3.25,0,0,1,2,.07A.6.6,0,0,1,372.94,68.75Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.49,77c-2,.7-3.58,1-4.25.58a.57.57,0,0,1-.31-.52V319.71l4.57,2.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,68.75v249l-.7.39-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46V71.71l1.62-.94.7-.39.05,0,.35-.18.51-.26c.55-.27,1.09-.52,1.61-.73l.48-.2.07,0c.27-.1.54-.2.8-.28l.21-.07.44-.14.66-.18.67-.15a3.25,3.25,0,0,1,2,.07A.6.6,0,0,1,372.94,68.75Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,77a.6.6,0,0,0-.33-.55c-1.12-.64-4.94.51-8.52,2.58l-7.32,4.23c-3.59,2.07-7.41,3.22-8.53,2.57a.56.56,0,0,1-.31-.51V77.06a.58.58,0,0,0,.31.52c1.12.64,4.94-.51,8.53-2.58l7.32-4.23c3.58-2.07,7.4-3.22,8.52-2.58a.6.6,0,0,1,.33.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,68.83V317.72l-.74.41-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0V81.77c0-1,1.86-2.73,4.77-4.41l1.6-.92,2.32-1.34.05,0,3.65-2.1.11-.06c2.46-1.42,4.1-2.88,4.35-3.83A.77.77,0,0,0,373,68.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,73.46V316.1a.6.6,0,0,0-.33-.54c-1-.61-4.43.35-7.79,2.16l-.74.41-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0V81.77a.57.57,0,0,0,.31.52,1.21,1.21,0,0,0,.38.13,2.76,2.76,0,0,0,.83,0,1.59,1.59,0,0,0,.36,0,7.49,7.49,0,0,0,1.18-.24c.32-.08.65-.17,1-.29l.35-.12.15-.05c.58-.21,1.19-.46,1.81-.74s1.55-.74,2.32-1.18l.05,0,.09-.05,5.7-3.29,1.62-.94.7-.39c3.4-1.83,6.79-2.79,7.83-2.18A.6.6,0,0,1,381.1,73.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,73.46V316.1a.6.6,0,0,0-.33-.54c-1-.61-4.43.35-7.79,2.16l-.74.41-1.62.94-5.7,3.29-.09.05-.05,0c-.32.18-.65.36-1,.52l-.39.2c-.32.17-.64.32-1,.46-.62.28-1.23.53-1.81.74s-1.07.36-1.55.49a4,4,0,0,1-3-.43h0V81.77a.57.57,0,0,0,.31.52,1.21,1.21,0,0,0,.38.13,2.76,2.76,0,0,0,.83,0,1.59,1.59,0,0,0,.36,0,7.49,7.49,0,0,0,1.18-.24c.32-.08.65-.17,1-.29l.35-.12.15-.05c.58-.21,1.19-.46,1.81-.74s1.55-.74,2.32-1.18l.05,0,.09-.05,5.7-3.29,1.62-.94.7-.39c3.4-1.83,6.79-2.79,7.83-2.18A.6.6,0,0,1,381.1,73.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,81.71V324.36c-.55.2-1.07.36-1.55.49a4,4,0,0,1-3-.43h0V81.77a.57.57,0,0,0,.31.52,1.21,1.21,0,0,0,.38.13,2.76,2.76,0,0,0,.83,0l.36,0a10.76,10.76,0,0,0,1.18-.24c.32-.08.65-.17,1-.29l.35-.12Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,73.46V316.1a.6.6,0,0,0-.33-.54c-1-.61-4.43.35-7.79,2.16l0,0-.7.39-1.62.94V76.42l1.62-.94.7-.39,0,0c3.36-1.81,6.75-2.77,7.79-2.16A.6.6,0,0,1,381.1,73.46Z",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1,81.66a.62.62,0,0,0-.33-.55c-1.12-.64-4.94.51-8.53,2.58l-7.31,4.23c-3.59,2.07-7.41,3.22-8.53,2.57a.56.56,0,0,1-.31-.51V81.77a.57.57,0,0,0,.31.52c1.12.64,4.94-.51,8.53-2.58l7.31-4.23c3.59-2.07,7.41-3.22,8.53-2.57a.59.59,0,0,1,.33.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.06,30.33a3.19,3.19,0,0,0-3.21.32,10.06,10.06,0,0,0-4.55,7.88,3.2,3.2,0,0,0,1.31,2.92l1.52.87a3.2,3.2,0,0,0,3.19-.32,10.06,10.06,0,0,0,4.55-7.88,3.17,3.17,0,0,0-1.37-3C307.12,31,306.44,30.56,306.06,30.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.77,39.37a10.06,10.06,0,0,1,4.55-7.88c2.51-1.45,4.55-.27,4.55,2.63A10.06,10.06,0,0,1,304.32,42C301.81,43.45,299.77,42.27,299.77,39.37Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.11,129.87,305.65,35.23a1,1,0,0,0-1,.09,3.1,3.1,0,0,0-1.4,2.42,1,1,0,0,0,.42.91l163.47,94.64a1,1,0,0,0,1-.09,3.08,3.08,0,0,0,1.4-2.42A1,1,0,0,0,469.11,129.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67,38.65l163.47,94.64a1,1,0,0,0,1-.09,2.55,2.55,0,0,0,.71-.65L303.46,36.8a2.54,2.54,0,0,0-.21.94A1,1,0,0,0,303.67,38.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.89,125.75a3.18,3.18,0,0,0-3.21.31,10.06,10.06,0,0,0-4.55,7.88,3.2,3.2,0,0,0,1.31,2.92l1.52.87a3.17,3.17,0,0,0,3.19-.32,10.06,10.06,0,0,0,4.55-7.88,3.18,3.18,0,0,0-1.37-3C472,126.37,471.27,126,470.89,125.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.6,134.78a10.06,10.06,0,0,1,4.55-7.88c2.51-1.45,4.55-.27,4.55,2.63a10.06,10.06,0,0,1-4.55,7.88C466.64,138.86,464.6,137.68,464.6,134.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66,49.05c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.41.23-.75,0-.75-.43A1.65,1.65,0,0,1,314.66,49.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.66,49.05c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.41.23-.75,0-.75-.43A1.65,1.65,0,0,1,314.66,49.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.69,42.77l-.55-.32a1.84,1.84,0,0,0-2.64-1.52,4.53,4.53,0,0,0-.72.33,7.27,7.27,0,0,0-2.41,2.43,7.67,7.67,0,0,0-1.27,3.94,2.08,2.08,0,0,0,3.43,2,5.38,5.38,0,0,0,.75-.53.73.73,0,0,1,.1.56,5.69,5.69,0,0,1-.6.4,3.71,3.71,0,0,1-1.83.56,2.21,2.21,0,0,1-1.11-.29,2.9,2.9,0,0,1-1.24-2.68A8.13,8.13,0,0,1,312,43.44a7.67,7.67,0,0,1,2.58-2.61,4.37,4.37,0,0,1,.43-.22,2.44,2.44,0,0,1,3.73,2.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,51.39c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.41.23-.74,0-.74-.43A1.64,1.64,0,0,1,318.72,51.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.75,45.11l-.54-.31a2.08,2.08,0,0,0-.93-1.47,2,2,0,0,0-1.72-.06,4.16,4.16,0,0,0-.72.33A7.27,7.27,0,0,0,316.43,46,7.67,7.67,0,0,0,315.16,50a2.47,2.47,0,0,0,1,2.25,2.44,2.44,0,0,0,2.44-.27,7.32,7.32,0,0,0,.76-.52.7.7,0,0,1,.1.55,5.81,5.81,0,0,1-.61.4,3.7,3.7,0,0,1-1.82.56,2.25,2.25,0,0,1-1.12-.29A2.9,2.9,0,0,1,314.66,50,8.1,8.1,0,0,1,316,45.79a7.8,7.8,0,0,1,2.58-2.62A2.84,2.84,0,0,1,319,43a2.43,2.43,0,0,1,3.73,2.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.78,53.73c.42-.24.75,0,.75.43a1.64,1.64,0,0,1-.75,1.29c-.41.24-.74,0-.74-.43A1.64,1.64,0,0,1,322.78,53.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.78,53.73c.42-.24.75,0,.75.43a1.64,1.64,0,0,1-.75,1.29c-.41.24-.74,0-.74-.43A1.64,1.64,0,0,1,322.78,53.73Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.27,47.16h0a2.1,2.1,0,0,0-.93-1.48,2.06,2.06,0,0,0-1.73-.06,4.08,4.08,0,0,0-.71.33,7.34,7.34,0,0,0-2.4,2.43,7.67,7.67,0,0,0-1.27,3.94,2.45,2.45,0,0,0,1,2.25,2.42,2.42,0,0,0,2.43-.27,5.39,5.39,0,0,0,.76-.52.7.7,0,0,1,.1.55,4.56,4.56,0,0,1-.61.4,3.65,3.65,0,0,1-1.82.56A2.21,2.21,0,0,1,320,55a2.9,2.9,0,0,1-1.24-2.68,8.18,8.18,0,0,1,1.34-4.18,7.8,7.8,0,0,1,2.58-2.62l.42-.21a2.43,2.43,0,0,1,3.74,2.16Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.85,56.07c.41-.23.74,0,.74.43a1.64,1.64,0,0,1-.74,1.29c-.41.24-.75,0-.75-.43A1.67,1.67,0,0,1,326.85,56.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.34,49.51h0A1.86,1.86,0,0,0,327.67,48a3.33,3.33,0,0,0-.7.32,7.46,7.46,0,0,0-2.41,2.43,7.67,7.67,0,0,0-1.27,3.94,2.08,2.08,0,0,0,3.43,2,5.3,5.3,0,0,0,.75-.52.7.7,0,0,1,.1.55,4.47,4.47,0,0,1-.6.4,3.71,3.71,0,0,1-1.83.56,2.21,2.21,0,0,1-1.11-.29,2.9,2.9,0,0,1-1.24-2.68,8.18,8.18,0,0,1,1.34-4.18,7.82,7.82,0,0,1,2.59-2.62,2.58,2.58,0,0,1,.41-.2,2.68,2.68,0,0,1,2.53-.07,2.73,2.73,0,0,1,1.22,2.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.91,58.41c.41-.23.74,0,.74.43a1.64,1.64,0,0,1-.74,1.29c-.41.24-.74,0-.74-.43A1.66,1.66,0,0,1,330.91,58.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.91,58.41c.41-.23.74,0,.74.43a1.64,1.64,0,0,1-.74,1.29c-.41.24-.74,0-.74-.43A1.66,1.66,0,0,1,330.91,58.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.4,51.85h0a2.1,2.1,0,0,0-.93-1.48,2,2,0,0,0-1.74-.06,3.92,3.92,0,0,0-.7.32,7.4,7.4,0,0,0-2.41,2.44A7.61,7.61,0,0,0,327.35,57a2.47,2.47,0,0,0,1,2.25,2.44,2.44,0,0,0,2.44-.27,6,6,0,0,0,.76-.52.7.7,0,0,1,.1.55,5.91,5.91,0,0,1-.61.41,3.79,3.79,0,0,1-1.82.55,2.15,2.15,0,0,1-1.12-.29A2.9,2.9,0,0,1,326.85,57a8.18,8.18,0,0,1,1.34-4.18,7.92,7.92,0,0,1,2.59-2.62,2.49,2.49,0,0,1,.4-.2,2.7,2.7,0,0,1,2.54-.07,2.73,2.73,0,0,1,1.22,2.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335,60.75c.42-.23.75,0,.75.43a1.63,1.63,0,0,1-.75,1.29c-.41.24-.74.05-.74-.43A1.66,1.66,0,0,1,335,60.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.46,54.19h0a2.1,2.1,0,0,0-.93-1.48,2,2,0,0,0-1.74-.06,3.92,3.92,0,0,0-.7.32,7.28,7.28,0,0,0-2.4,2.44,7.61,7.61,0,0,0-1.27,3.93,2.45,2.45,0,0,0,1,2.25,2.42,2.42,0,0,0,2.43-.27,5.39,5.39,0,0,0,.76-.52.7.7,0,0,1,.1.55,5.91,5.91,0,0,1-.61.41,3.63,3.63,0,0,1-1.82.55,2.12,2.12,0,0,1-1.11-.29,2.9,2.9,0,0,1-1.24-2.68,8.17,8.17,0,0,1,1.34-4.17,7.65,7.65,0,0,1,2.58-2.63,2.49,2.49,0,0,1,.4-.2,2.7,2.7,0,0,1,2.54-.07A2.73,2.73,0,0,1,339,54.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,63.09c.41-.23.74,0,.74.43a1.64,1.64,0,0,1-.74,1.29c-.41.24-.75,0-.75-.43A1.67,1.67,0,0,1,339,63.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,63.09c.41-.23.74,0,.74.43a1.64,1.64,0,0,1-.74,1.29c-.41.24-.75,0-.75-.43A1.67,1.67,0,0,1,339,63.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.07,56.85l-.54-.31a2.09,2.09,0,0,0-.93-1.5,2,2,0,0,0-1.76,0,3.7,3.7,0,0,0-.68.31,7.25,7.25,0,0,0-2.41,2.45,7.61,7.61,0,0,0-1.27,3.93,2.07,2.07,0,0,0,3.43,2,4.58,4.58,0,0,0,.75-.52.7.7,0,0,1,.1.55,5.79,5.79,0,0,1-.6.41,3.69,3.69,0,0,1-1.83.55,2.12,2.12,0,0,1-1.11-.29A2.9,2.9,0,0,1,335,61.68a8.18,8.18,0,0,1,1.34-4.18,7.59,7.59,0,0,1,2.59-2.63,3.6,3.6,0,0,1,.39-.2,2.45,2.45,0,0,1,3.77,2.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.1,65.44c.41-.24.75,0,.75.42a1.64,1.64,0,0,1-.75,1.29c-.41.24-.74,0-.74-.43A1.62,1.62,0,0,1,343.1,65.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.13,59.19l-.54-.31a2.09,2.09,0,0,0-.93-1.5,2,2,0,0,0-1.74,0,3.85,3.85,0,0,0-.7.31,7.24,7.24,0,0,0-2.42,2.44A7.69,7.69,0,0,0,339.54,64,2.08,2.08,0,0,0,343,66a6.13,6.13,0,0,0,.76-.53.71.71,0,0,1,.1.55,5.91,5.91,0,0,1-.61.41,3.68,3.68,0,0,1-1.82.55,2.15,2.15,0,0,1-1.12-.29A2.9,2.9,0,0,1,339,64a8.17,8.17,0,0,1,1.34-4.17A7.8,7.8,0,0,1,343,57.21a2.33,2.33,0,0,1,.39-.19,2.44,2.44,0,0,1,3.77,2.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,67.78c.41-.24.74,0,.74.43a1.62,1.62,0,0,1-.74,1.28c-.42.24-.75.05-.75-.43A1.61,1.61,0,0,1,347.17,67.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,67.78c.41-.24.74,0,.74.43a1.62,1.62,0,0,1-.74,1.28c-.42.24-.75.05-.75-.43A1.61,1.61,0,0,1,347.17,67.78Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.19,61.53l-.54-.31a2.09,2.09,0,0,0-.93-1.5,2,2,0,0,0-1.74,0,3.77,3.77,0,0,0-.69.31,7.37,7.37,0,0,0-2.42,2.45,7.68,7.68,0,0,0-1.26,3.92,2.08,2.08,0,0,0,3.43,2,6,6,0,0,0,.75-.53.73.73,0,0,1,.1.56c-.2.14-.4.28-.6.4a3.69,3.69,0,0,1-1.83.55,2.21,2.21,0,0,1-1.11-.28,2.92,2.92,0,0,1-1.24-2.68,8.16,8.16,0,0,1,1.33-4.17,7.82,7.82,0,0,1,2.6-2.64,3.37,3.37,0,0,1,.38-.19,2.44,2.44,0,0,1,3.77,2.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.23,70.12c.41-.24.74-.05.74.43a1.62,1.62,0,0,1-.74,1.28c-.41.24-.75,0-.75-.43A1.63,1.63,0,0,1,351.23,70.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.26,63.88l-.54-.31a2.11,2.11,0,0,0-.93-1.51A2,2,0,0,0,352,62a3.77,3.77,0,0,0-.69.31,7.37,7.37,0,0,0-2.42,2.45,7.68,7.68,0,0,0-1.26,3.92,2.08,2.08,0,0,0,3.43,2,5.38,5.38,0,0,0,.75-.53.73.73,0,0,1,.1.56,5.69,5.69,0,0,1-.6.4,3.71,3.71,0,0,1-1.83.56,2.21,2.21,0,0,1-1.11-.29,2.91,2.91,0,0,1-1.24-2.68,8.16,8.16,0,0,1,1.33-4.17,7.82,7.82,0,0,1,2.6-2.64,3.37,3.37,0,0,1,.38-.19,2.45,2.45,0,0,1,3.78,2.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,72.46c.41-.24.75,0,.75.43a1.67,1.67,0,0,1-.75,1.29c-.41.23-.74,0-.74-.43A1.64,1.64,0,0,1,355.29,72.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.29,72.46c.41-.24.75,0,.75.43a1.67,1.67,0,0,1-.75,1.29c-.41.23-.74,0-.74-.43A1.64,1.64,0,0,1,355.29,72.46Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.32,66.22l-.54-.31a2.11,2.11,0,0,0-.93-1.51,2,2,0,0,0-1.75,0,4.1,4.1,0,0,0-.69.31A7.37,7.37,0,0,0,353,67.12,7.68,7.68,0,0,0,351.73,71a2.08,2.08,0,0,0,3.43,2,6.13,6.13,0,0,0,.76-.53.73.73,0,0,1,.1.56,5.81,5.81,0,0,1-.61.4,3.7,3.7,0,0,1-1.82.56,2.25,2.25,0,0,1-1.12-.29A2.91,2.91,0,0,1,351.23,71a8.25,8.25,0,0,1,1.33-4.17,8,8,0,0,1,2.6-2.64,3.37,3.37,0,0,1,.38-.19,2.45,2.45,0,0,1,3.78,2.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,74.8c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.42.23-.75,0-.75-.43A1.63,1.63,0,0,1,359.36,74.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.38,68.56l-.54-.31a2.11,2.11,0,0,0-.93-1.51,2,2,0,0,0-1.75,0,3.7,3.7,0,0,0-.68.31,7.19,7.19,0,0,0-2.42,2.45,7.68,7.68,0,0,0-1.26,3.92,2.08,2.08,0,0,0,3.43,2,6,6,0,0,0,.75-.53.73.73,0,0,1,.1.56,7,7,0,0,1-.6.4,3.71,3.71,0,0,1-1.83.56,2.21,2.21,0,0,1-1.11-.29,2.9,2.9,0,0,1-1.24-2.68,8.12,8.12,0,0,1,1.33-4.16,7.82,7.82,0,0,1,2.6-2.64,3.37,3.37,0,0,1,.38-.19,2.66,2.66,0,0,1,2.55-.08A2.7,2.7,0,0,1,363.38,68.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,77.14c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.41.23-.75,0-.75-.43A1.65,1.65,0,0,1,363.42,77.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,77.14c.41-.24.74,0,.74.43a1.66,1.66,0,0,1-.74,1.29c-.41.23-.75,0-.75-.43A1.65,1.65,0,0,1,363.42,77.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.45,70.92l-.54-.32a1.84,1.84,0,0,0-2.7-1.55,3,3,0,0,0-.67.3,7.24,7.24,0,0,0-2.43,2.46,7.63,7.63,0,0,0-1.25,3.91,2.08,2.08,0,0,0,3.43,2,5.38,5.38,0,0,0,.75-.53.73.73,0,0,1,.11.56,7.07,7.07,0,0,1-.61.4,3.71,3.71,0,0,1-1.83.56,2.21,2.21,0,0,1-1.11-.29,2.9,2.9,0,0,1-1.24-2.68,8.12,8.12,0,0,1,1.33-4.16,7.82,7.82,0,0,1,2.6-2.64,3.37,3.37,0,0,1,.38-.19,2.44,2.44,0,0,1,3.78,2.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.48,79.48c.41-.24.75,0,.75.43a1.67,1.67,0,0,1-.75,1.29c-.41.23-.74,0-.74-.43A1.64,1.64,0,0,1,367.48,79.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.51,73.26,371,73a2.07,2.07,0,0,0-.93-1.53,2,2,0,0,0-1.77,0,3,3,0,0,0-.67.3,7.24,7.24,0,0,0-2.43,2.46,7.63,7.63,0,0,0-1.25,3.91,2.47,2.47,0,0,0,1,2.25,2.44,2.44,0,0,0,2.44-.27,7.32,7.32,0,0,0,.76-.52.7.7,0,0,1,.1.55,5.81,5.81,0,0,1-.61.4,3.7,3.7,0,0,1-1.82.56,2.25,2.25,0,0,1-1.12-.29,2.9,2.9,0,0,1-1.24-2.68,8.09,8.09,0,0,1,1.33-4.15,7.86,7.86,0,0,1,2.6-2.65,3.24,3.24,0,0,1,.37-.19,2.44,2.44,0,0,1,3.79,2.19Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pot--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.74,288c9.21-9.5,14.61-48.16,5.63-55.69H240.69c-9,7.53-3.58,46.17,5.62,55.68l.26.26.31.31a10.18,10.18,0,0,0,.84.75l.22.18c.22.18.44.35.69.53a14.13,14.13,0,0,0,1.19.77c7.57,4.42,19.85,4.42,27.42,0h0a11.17,11.17,0,0,0,1.2-.78c.23-.16.44-.33.65-.49l.27-.22c.29-.23.55-.48.8-.72l.37-.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.66,229.28c-10.43,6.09-10.43,16,0,22s27.32,6.09,37.75,0,10.42-15.95,0-22S255.08,223.2,244.66,229.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.67,232.21c-7.66,4.47-7.66,11.72,0,16.19s20.07,4.46,27.72,0,7.66-11.72,0-16.19S257.32,227.74,249.67,232.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.39,239.89c-7.65-4.47-20.07-4.47-27.72,0a12.79,12.79,0,0,0-4.59,4.25,12.9,12.9,0,0,0,4.59,4.26c7.65,4.46,20.07,4.46,27.72,0a12.9,12.9,0,0,0,4.59-4.26A12.79,12.79,0,0,0,277.39,239.89Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243,161l17.34,13.76L243.61,167a46.43,46.43,0,0,0,2.91,15.89s8.26,4.93,13.06,9.26l-12.86-5.08s-.88,8.48,2.65,21.4c.92,3.39,4.72,9.85,7.13,14.68a54.37,54.37,0,0,0,3.73,6.45c.08.14.17.26.26.4q4.41-2.53,9.17-4.9c2.06-4.34,4.76-15.08,5.73-23.87,3.7-33.66-21.75-52.95-42.21-59.42C233.18,141.83,240.21,150.65,243,161Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.54,162.42c3.54,3.56,5.61,8.25,7.2,12.93a68.4,68.4,0,0,1,3.08,14.56,63.13,63.13,0,0,1-3.67,29.23h0a.49.49,0,0,0,.28.63.48.48,0,0,0,.63-.28h0a63.89,63.89,0,0,0,3.24-29.64A68.28,68.28,0,0,0,265,175.27C263.3,170.6,261.14,165.92,257.54,162.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.11,178.66l0,0c-.44.51-7.56,9-18.13,25.46L282.36,207l13,2.26-7,11-17.32,3.58,13.53,2.2s-3.76,13.2-13.44,18.71c-5.34,3-7.95,3.5-9.56,2-1.12-1.06-1.38-7.4-2.32-13.05s-1-14.83,4.33-25.92a34.43,34.43,0,0,1,5.54-8.15C281.94,185.37,306.15,178.49,318.11,178.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.7,184.42c-9.1,4-17.71,9.47-24.48,16.91a48.32,48.32,0,0,0-8.38,12.44A45.67,45.67,0,0,0,263,228.24a.05.05,0,0,0,.05,0,.07.07,0,0,0,.05,0,58.53,58.53,0,0,1,4.61-14.06,54.38,54.38,0,0,1,8.08-12.34c6.55-7.45,15-13.1,23.94-17.34a0,0,0,0,0,0-.06A.05.05,0,0,0,299.7,184.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26,185.93h0a37.12,37.12,0,0,1,4.43.2,71.19,71.19,0,0,1,16.94,4.12c2,.76,4.05,1.61,6.05,2.57,1,.47,2,1,3,1.5a49.11,49.11,0,0,1,13,9.81,31.38,31.38,0,0,1,4.47,6.28c.15.3.33.58.47.88h0c.38.77.72,1.53,1,2.28a42.33,42.33,0,0,1,3.82,20.85c-.18,5-1.9,10.82-2.88,11.77a2,2,0,0,1-.44.32c-1.44.92-3.73.39-8-2-8.58-4.79-11.94-16.95-11.94-16.95l11.92-2-15.31-3.06-6.22-9.69L245,210.71l-15.54-2.4C220,193.83,213.67,186.4,213.28,186l0,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.69,186.13a71.19,71.19,0,0,1,16.94,4.12c2,.76,4.05,1.61,6.05,2.57,1,.47,2,1,3,1.5a49.11,49.11,0,0,1,13,9.81,31.38,31.38,0,0,1,4.47,6.28c.15.3.33.58.47.88h0c.38.77.72,1.53,1,2.28a42.33,42.33,0,0,1,3.82,20.85c-.18,5-1.9,10.82-2.88,11.77a2,2,0,0,1-.44.32,2.73,2.73,0,0,1-.94.35c1-7.83-2.8-27.68-8.63-35.85-6.07-8.5-20.46-20.82-40.25-25.07l0,0A36.39,36.39,0,0,1,217.69,186.13Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.21,246.87a67.06,67.06,0,0,0-1.13-17.31,56,56,0,0,0-5.74-16.43c-2.93-5.11-7.15-9.28-11.63-13a65.19,65.19,0,0,0-14.92-8.94.06.06,0,0,0-.07,0s0,.05,0,.07a84.82,84.82,0,0,1,14.34,9.6,61.5,61.5,0,0,1,6.31,5.87,38.11,38.11,0,0,1,5.26,6.76,55.32,55.32,0,0,1,5.94,16.12,66.84,66.84,0,0,1,1.51,17.22s0,0,0,0A.06.06,0,0,0,262.21,246.87Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.26 80.4 233.61 81.17 267.19 61.79 265.84 61.01 232.26 80.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.84 61.01 233.61 79.62 233.61 51.68 265.84 33.07 265.84 61.01",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53,30,232.26,50.91V83.5l36.27-20.94Zm-1.34,31.82L233.61,81.17V51.68l33.58-19.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.19 61.79 265.84 61.01 265.84 33.07 267.19 32.29 267.19 61.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.53 29.97 267.19 29.19 230.92 50.13 232.26 50.91 268.53 29.97",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.92 50.13 232.26 50.91 232.26 83.5 230.92 82.72 230.92 50.13",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,56.31c1.25-.72,2.27-.13,2.27,1.31a5,5,0,0,1-2.27,3.93c-1.25.72-2.27.14-2.27-1.31A5,5,0,0,1,259.52,56.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,50.41l17.07-9.86c.47-.28.86-.06.86.49v.05a1.91,1.91,0,0,1-.86,1.49L241.2,52.45c-.48.28-.86,0-.86-.49V51.9A1.88,1.88,0,0,1,241.2,50.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,58.18,261,45.2c.47-.27.85-.14.85.28a1.74,1.74,0,0,1-.85,1.28l-22.49,13c-.48.27-.86.15-.85-.29A1.71,1.71,0,0,1,238.5,58.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,61.28,261,48.3c.47-.27.85-.15.85.28a1.74,1.74,0,0,1-.85,1.28l-22.49,13c-.48.27-.86.14-.85-.29A1.71,1.71,0,0,1,238.5,61.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,64.38,261,51.4c.47-.27.85-.15.85.28A1.71,1.71,0,0,1,261,53l-22.49,13c-.48.27-.86.14-.85-.29A1.71,1.71,0,0,1,238.5,64.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.49,63a1.22,1.22,0,0,1-.56.14c-.48,0-.44-.49-.42-.82,0-.15-.21-.39-.32-.19-.29.53-.66,1-1,1.53-.19.31-.55,1-1,.92-.19,0-.26-.25-.26-.51a2.52,2.52,0,0,0,.3-1.4c0-.15-.26-.32-.34-.13a4.25,4.25,0,0,0-.29,1.29,7,7,0,0,1-.73,1.08c-.15.21-.29.44-.46.64,0,0-.12.16-.19.17s-.14-.06-.16-.17a1.06,1.06,0,0,1,.07-.46h0a.06.06,0,0,0,0,0h0c0-.16-.2-.38-.28-.19a6.76,6.76,0,0,1-1.32,2.2l-.08.07c0-.09,0-.18,0-.27a2.43,2.43,0,0,0-.1-.61c0-.1-.21-.25-.3-.12a10.62,10.62,0,0,1-1.5,2.07,3.13,3.13,0,0,1-.31.22c-.1-.06.05-.61.08-.69.06-.24.14-.48.22-.72a3,3,0,0,0,.18-.6c0-.18-.29-.46-.35-.22s-.11.35-.21.65a14.82,14.82,0,0,1-1.26,2.14,4.89,4.89,0,0,1-1.75,1.69c-.2.11-.58.27-.79.11s-.2-.44-.21-.64a5.42,5.42,0,0,1,.21-1.55,9.6,9.6,0,0,0,1.95-1.38,6.52,6.52,0,0,0,1.47-1.63c.2-.36.32-1-.16-1.16a1.33,1.33,0,0,0-1,.25,4.58,4.58,0,0,0-1.07.83,6.11,6.11,0,0,0-1.34,2.46c0,.13-.1.32-.16.53a4.11,4.11,0,0,1-2.47.41s-.07.1,0,.11a4,4,0,0,0,2.42-.23c-.22.94-.34,2.18.54,2.42s1.93-.85,2.4-1.48a10.17,10.17,0,0,0,.94-1.52.76.76,0,0,1,.08-.11c0,.44.08.75.51.68s.83-.68,1.07-1,.43-.65.63-1c0,.39.11.84.49.76s.68-.73.86-1a7.2,7.2,0,0,0,.42-.7.94.94,0,0,0,.09.12c.31.34.68,0,.88-.28s.61-.78.88-1.2a.73.73,0,0,0,.37.42c.48.23.93-.17,1.21-.52a10.78,10.78,0,0,0,.9-1.46.68.68,0,0,0,.33.46,1.12,1.12,0,0,0,1.13-.07C255.79,63.19,255.64,62.87,255.49,63ZM245,64.82c.23-.11.69-.3.72.08a1.31,1.31,0,0,1-.31.65,8.57,8.57,0,0,1-1.3,1.39,10.78,10.78,0,0,1-1.64,1.25A5.29,5.29,0,0,1,245,64.82Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.26 125.94 233.61 126.72 267.19 107.33 265.84 106.56 232.26 125.94",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.84 106.56 233.61 125.17 233.61 97.23 265.84 78.62 265.84 106.56",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53,75.51,232.26,96.45v32.6l36.27-20.94Zm-1.34,31.82-33.58,19.39V97.23l33.58-19.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "267.19 107.33 265.84 106.56 265.84 78.62 267.19 77.84 267.19 107.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.53 75.51 267.19 74.74 230.92 95.68 232.26 96.45 268.53 75.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.92 95.68 232.26 96.45 232.26 129.05 230.92 128.27 230.92 95.68",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.52,101.86c1.25-.72,2.27-.14,2.27,1.31a5,5,0,0,1-2.27,3.93c-1.25.72-2.27.13-2.27-1.31A5,5,0,0,1,259.52,101.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.2,96l17.07-9.87c.47-.27.86,0,.86.5v0a1.92,1.92,0,0,1-.86,1.49L241.2,98c-.48.27-.86,0-.86-.5v0A1.88,1.88,0,0,1,241.2,96Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,103.72l22.47-13c.47-.27.85-.15.85.28A1.71,1.71,0,0,1,261,92.3l-22.49,13c-.48.27-.86.14-.85-.29A1.74,1.74,0,0,1,238.5,103.72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,106.82l22.47-13c.47-.27.85-.15.85.28A1.71,1.71,0,0,1,261,95.4l-22.49,13c-.48.28-.86.15-.85-.28A1.74,1.74,0,0,1,238.5,106.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,109.92,261,97c.47-.27.85-.15.85.28A1.71,1.71,0,0,1,261,98.5l-22.49,13c-.48.28-.86.15-.85-.28A1.74,1.74,0,0,1,238.5,109.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.49,108.49a1.23,1.23,0,0,1-.56.15c-.48,0-.44-.49-.42-.82,0-.16-.21-.39-.32-.19-.29.52-.66,1-1,1.52-.19.32-.55,1-1,.92-.19,0-.26-.24-.26-.5a2.52,2.52,0,0,0,.3-1.4c0-.15-.26-.33-.34-.13a4.25,4.25,0,0,0-.29,1.29,7.56,7.56,0,0,1-.73,1.08,7.26,7.26,0,0,1-.46.63s-.12.17-.19.18-.14-.07-.16-.17a1,1,0,0,1,.07-.46h0a.08.08,0,0,0,0,0h0c0-.15-.2-.37-.28-.18a6.61,6.61,0,0,1-1.32,2.19l-.08.08c0-.09,0-.18,0-.27a2.43,2.43,0,0,0-.1-.61c0-.1-.21-.25-.3-.12a10.55,10.55,0,0,1-1.5,2.06,1.51,1.51,0,0,1-.31.22c-.1-.06.05-.6.08-.68.06-.25.14-.49.22-.72a3,3,0,0,0,.18-.6c0-.18-.29-.47-.35-.22s-.11.35-.21.65a14.82,14.82,0,0,1-1.26,2.14,5,5,0,0,1-1.75,1.69c-.2.11-.58.26-.79.1s-.2-.43-.21-.63a5.53,5.53,0,0,1,.21-1.56,9.55,9.55,0,0,0,1.95-1.37,6.69,6.69,0,0,0,1.47-1.63c.2-.36.32-1-.16-1.16a1.33,1.33,0,0,0-1,.25,4.58,4.58,0,0,0-1.07.83,6.13,6.13,0,0,0-1.34,2.45c0,.14-.1.33-.16.54a4.18,4.18,0,0,1-2.47.41s-.07.1,0,.11a4.1,4.1,0,0,0,2.42-.23c-.22.94-.34,2.18.54,2.42s1.93-.85,2.4-1.48a10.71,10.71,0,0,0,.94-1.52.76.76,0,0,1,.08-.11c0,.43.08.75.51.68s.83-.69,1.07-1,.43-.64.63-1c0,.39.11.83.49.76s.68-.73.86-1a6.31,6.31,0,0,0,.42-.71.6.6,0,0,0,.09.13c.31.34.68,0,.88-.29s.61-.77.88-1.19a.73.73,0,0,0,.37.42c.48.22.93-.17,1.21-.53a10.67,10.67,0,0,0,.9-1.45.68.68,0,0,0,.33.46,1.12,1.12,0,0,0,1.13-.07C255.79,108.74,255.64,108.41,255.49,108.49ZM245,110.37c.23-.11.69-.3.72.07a1.3,1.3,0,0,1-.31.66,8.57,8.57,0,0,1-1.3,1.39,11.47,11.47,0,0,1-1.64,1.25A5.29,5.29,0,0,1,245,110.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.05,394.15H83.51l-1.67,10.2h0a1.84,1.84,0,0,1-1,1.26,5.57,5.57,0,0,1-5.06,0,1.87,1.87,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.05,394.15H83.51l-1.67,10.2h0a1.84,1.84,0,0,1-1,1.26,5.57,5.57,0,0,1-5.06,0,1.87,1.87,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.34,308H232.8l-1.68,10.2h0a1.89,1.89,0,0,1-1,1.26,5.61,5.61,0,0,1-5.05,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.34,308H232.8l-1.68,10.2h0a1.89,1.89,0,0,1-1,1.26,5.61,5.61,0,0,1-5.05,0,1.89,1.89,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,376.48H52.94l-1.67,10.2h0a1.89,1.89,0,0,1-1,1.26,5.63,5.63,0,0,1-5.06,0,1.87,1.87,0,0,1-1-1.26h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48,376.48H52.94l-1.67,10.2h0a1.89,1.89,0,0,1-1,1.26,5.63,5.63,0,0,1-5.06,0,1.87,1.87,0,0,1-1-1.26h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.9 265.93 39.9 380.99 78.34 403.21 78.34 288.15 39.9 265.93",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.34 403.21 239.1 310.44 239.1 195.38 78.34 288.15 78.34 403.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.36 374.9 129.42 373.71 129.42 258.65 127.36 259.84 127.36 374.9",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "197.48 334.42 199.54 333.23 199.54 218.17 197.48 219.36 197.48 334.42",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.55,196.08a1.56,1.56,0,0,0-.92-1.28l-41.88-24.2a4.85,4.85,0,0,0-4.42,0L34.25,264.66a1.54,1.54,0,0,0-.91,1.27v2.93a1.54,1.54,0,0,0,.91,1.28l41.89,24.21a4.85,4.85,0,0,0,4.42,0l163.07-94.11a1.55,1.55,0,0,0,.92-1.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.34,265.93v2.93a1.54,1.54,0,0,0,.91,1.28l41.89,24.21a4.5,4.5,0,0,0,2.2.53l36.15-50.18-30.06-9-50.18,29A1.54,1.54,0,0,0,33.34,265.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.33,170.6,34.25,264.66a1.35,1.35,0,0,0,0,2.55l41.89,24.21a4.91,4.91,0,0,0,4.42,0l163.07-94.07a1.35,1.35,0,0,0,0-2.55l-41.88-24.2A4.85,4.85,0,0,0,197.33,170.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,296.25c0,.7,2.12.05,4.74-1.46l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.28L94,295Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.57,230.73c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29l-15.73,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,270.59c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29l-15.74,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,297.85c0,.71,2.12.06,4.74-1.46l6.25-3.59c2.62-1.52,4.74-3.33,4.74-4v-1.28l-15.74,9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82,337c0,.71,2.12.06,4.74-1.45l6.25-3.6c2.62-1.51,4.74-3.32,4.74-4v-1.29l-15.74,9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.51 262.25 128.07 302.93 128.07 305.2 198.51 264.52 198.51 262.25",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "198.51 301.39 128.07 342.06 128.07 344.33 198.51 303.66 198.51 301.39",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--board--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.33,36.58l.93.54V164.56c0,3-1.83,6.51-4.09,7.81L44.6,244.86a2.67,2.67,0,0,1-2.55.28c-.21-.1-.9-.52-1.06-.61a3.62,3.62,0,0,1-1.41-3.29V113.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6,244.86l125.57-72.49c2.26-1.3,4.09-4.8,4.09-7.81V37.12L40.51,114.34V241.77C40.51,244.78,42.34,246.17,44.6,244.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.26,38.85V164.56c0,2.64-1.64,5.82-3.59,6.95L44.1,244a2.33,2.33,0,0,1-1.12.35c-1.08,0-1.47-1.39-1.47-2.58V114.92L173.26,38.85m1-1.73L40.51,114.34V241.77c0,2.24,1,3.58,2.47,3.58a3.17,3.17,0,0,0,1.62-.49l125.57-72.49c2.26-1.3,4.09-4.8,4.09-7.81V37.12Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tube--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.85,118.29l-3.12-5.42,136.88-79h0a1.52,1.52,0,0,1,1.6.12,4.92,4.92,0,0,1,2.21,3.84,1.59,1.59,0,0,1-.6,1.4h0l0,0h0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.51,116.85A4.88,4.88,0,0,0,38.3,113c-1.22-.71-2.21-.13-2.21,1.28a4.9,4.9,0,0,0,2.21,3.83C39.52,118.84,40.51,118.26,40.51,116.85Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,124.72a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l16.28-9.4a.5.5,0,0,1,.5.86l-16.28,9.4A.47.47,0,0,1,143.52,124.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,129.32a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l16.28-9.4a.5.5,0,1,1,.5.86l-16.28,9.4A.47.47,0,0,1,143.52,129.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,133.92a.51.51,0,0,1-.44-.25.49.49,0,0,1,.19-.68l16.28-9.4a.5.5,0,0,1,.5.86l-16.28,9.4A.47.47,0,0,1,143.52,133.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,138.52a.5.5,0,0,1-.33-.12l-14.51-12.55a.51.51,0,0,1-.05-.71.49.49,0,0,1,.7,0l14.24,12.32,16-9.23a.51.51,0,0,1,.68.19.49.49,0,0,1-.18.68l-16.28,9.4A.47.47,0,0,1,143.52,138.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,162.73a.5.5,0,0,1-.25-.93L152,152.4a.49.49,0,0,1,.68.18.51.51,0,0,1-.18.69l-16.28,9.4A.57.57,0,0,1,136,162.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,167.33a.5.5,0,0,1-.25-.93L152,157a.5.5,0,0,1,.5.86l-16.28,9.41A.57.57,0,0,1,136,167.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,171.93a.5.5,0,0,1-.25-.93L152,161.6a.5.5,0,0,1,.5.86l-16.28,9.4A.47.47,0,0,1,136,171.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,176.53a.5.5,0,0,1-.33-.12l-14.51-12.55a.5.5,0,0,1,.65-.75L136,175.42l16-9.22a.5.5,0,0,1,.5.86l-16.28,9.4A.47.47,0,0,1,136,176.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,183.57a2.43,2.43,0,0,0,.44-.75c.13-.4,0-.61-.19-.47L69,191.75a2,2,0,0,0-.68,1c-.14.4-.06.61.18.47l16.28-9.4A.82.82,0,0,0,85.07,183.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,188.17a2.43,2.43,0,0,0,.44-.75c.13-.4,0-.61-.19-.47L69,196.35a2,2,0,0,0-.68,1c-.14.4-.06.61.18.47l16.28-9.4A.82.82,0,0,0,85.07,188.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,192.77a2.43,2.43,0,0,0,.44-.75c.13-.4,0-.61-.19-.47L69,201a2,2,0,0,0-.68,1c-.14.4-.06.61.18.47L84.82,193A1,1,0,0,0,85.07,192.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.57,197.13a2.07,2.07,0,0,0,.33-.5L96.69,174.9c.12-.28.24-.6-.09-.81s-.61.16-.75.42L85,196.32l-16,9.23a2,2,0,0,0-.68,1c-.14.4-.06.61.18.47l16.28-9.4A6.06,6.06,0,0,0,85.57,197.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.47,164a2.53,2.53,0,0,0,.43-.75c.14-.4.06-.61-.18-.47l-16.28,9.4a1.94,1.94,0,0,0-.68,1c-.14.4-.06.61.18.47l16.28-9.4A1.23,1.23,0,0,0,67.47,164Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.47,168.63a2.53,2.53,0,0,0,.43-.75c.14-.4.06-.61-.18-.48l-16.28,9.4a2,2,0,0,0-.68,1c-.14.4-.06.61.18.47l16.28-9.4A1.23,1.23,0,0,0,67.47,168.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.47,173.22a2.36,2.36,0,0,0,.43-.74c.14-.4.06-.61-.18-.48l-16.28,9.4a2,2,0,0,0-.68,1c-.14.39-.06.61.18.47l16.28-9.4A1,1,0,0,0,67.47,173.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,177.59a2.07,2.07,0,0,0,.33-.5l10.79-21.73c.12-.28.23-.6-.09-.82s-.61.16-.76.43L67.41,176.78l-16,9.22a2,2,0,0,0-.68,1c-.14.4-.06.62.18.48l16.28-9.4A6.06,6.06,0,0,0,68,177.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Uterus--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.71,105.42c-1.32,2.19-1.68,4.24-4.11,4.63a19.73,19.73,0,0,1-6,.08c-.71-.22-.29-2.79-.29-2.79s-2.22,5.27-1.35,8.44c.65-1.94,1.07-2.84,2.61-3.55s4.69-1.37,5.64-.26,1.8,4.79,5.71,2.91Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.71,105.42c-1.32,2.19-1.68,4.24-4.11,4.63a19.73,19.73,0,0,1-6,.08c-.71-.22-.29-2.79-.29-2.79s-2.22,5.27-1.35,8.44c.65-1.94,1.07-2.84,2.61-3.55s4.69-1.37,5.64-.26,1.8,4.79,5.71,2.91Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,136.22c1.32.67,1.68,2.31,4.11-.11a67.36,67.36,0,0,0,6-6.88c.71-1,.29-3.12.29-3.12A8.6,8.6,0,0,1,93.12,133c-.65-1.19-1.07-1.62-2.61-.54s-4.69,4-5.64,6.26-1.8,6.86-5.71,9.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.35,136.22c1.32.67,1.68,2.31,4.11-.11a67.36,67.36,0,0,0,6-6.88c.71-1,.29-3.12.29-3.12A8.6,8.6,0,0,1,93.12,133c-.65-1.19-1.07-1.62-2.61-.54s-4.69,4-5.64,6.26-1.8,6.86-5.71,9.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,198.46c1-10.54-1.61-15.76-2.55-23.43s-.49-12.87,1-20.67-2.63-7-6-14.87-2.55-12.12-4.59-16.61S78.27,121.45,73.77,119,63.53,117.08,61,120.54a9,9,0,0,0,2,13c4.45,3.19,9.37-3.42,12.23-2.54-2.9,2.11-1.79,4-1.79,4s-5.26,12.73-6.17,13.92,0,4.53,0,4.53S56,142.4,56,129.5s10-17.15,15.61-15.08,9.23,3.3,16.08,1.11S97,100.27,108,93.93s13.52,3.8,20.37-1.92,10.43-11.09,16.07-19.67,15.62-15.86,15.62-3-11.32,37-11.32,37,.91-4.39,0-4.53S142.6,95,142.6,95s1.12-3.17-1.78-1.91c2.86-4.2,7.78-3.27,12.23-11.59s5.09-14.67,2-15.3c-2.54-.52-8.28,5.55-12.78,13.21S127.39,96,125.35,102.88s-1.17,10.11-4.59,21.9-7.48,15.72-6,21.86,1.89,10.81,1,19.57-3.56,17-2.55,26.37C109.82,191.91,106.44,193.66,102.94,198.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.94,198.46c1-10.54-1.61-15.76-2.55-23.43s-.49-12.87,1-20.67-2.63-7-6-14.87-2.55-12.12-4.59-16.61S78.27,121.45,73.77,119,63.53,117.08,61,120.54a9,9,0,0,0,2,13c4.45,3.19,9.37-3.42,12.23-2.54-2.9,2.11-1.79,4-1.79,4s-5.26,12.73-6.17,13.92,0,4.53,0,4.53S56,142.4,56,129.5s10-17.15,15.61-15.08,9.23,3.3,16.08,1.11S97,100.27,108,93.93s13.52,3.8,20.37-1.92,10.43-11.09,16.07-19.67,15.62-15.86,15.62-3-11.32,37-11.32,37,.91-4.39,0-4.53S142.6,95,142.6,95s1.12-3.17-1.78-1.91c2.86-4.2,7.78-3.27,12.23-11.59s5.09-14.67,2-15.3c-2.54-.52-8.28,5.55-12.78,13.21S127.39,96,125.35,102.88s-1.17,10.11-4.59,21.9-7.48,15.72-6,21.86,1.89,10.81,1,19.57-3.56,17-2.55,26.37C109.82,191.91,106.44,193.66,102.94,198.46Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.66,117.84c-7.28.82-11.58-.19-17.83-2.13s-10.95,2.63-12.51,8.8c-1.11,4.41.28,12.16,3.67,16.68s6.29,5.41,6.29,5.41l3.46-9.8s-4.09,2.36-7.36.22-5.9-6.52-5-12.45,6.36-9.35,11.43-7.87S79.19,119.31,87.66,117.84Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.4,94.32c7.28-7.59,11.58-13.56,17.83-22.72s11-10,12.51-5.64c1.11,3.12-.28,12.48-3.67,20.9a73.5,73.5,0,0,1-6.29,12.7l-3.46-5.82a22.36,22.36,0,0,0,7.35-8.27c3.27-5.91,5.91-13.34,5-18.21s-6.36-2-11.43,5.33S136.87,86,128.4,94.32Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,111.76c-4.08,2.36-15.44,6.3-20.37,6.08,4,.14,8.58.92,10.74,3.4s2.37,8,4,10.11,5.47,3.29,5.64,9.84c.17-6.75,4-12.33,5.64-16.35s1.82-9.73,4-14.71,6.75-11.06,10.74-15.81C123.46,100.24,112.11,109.41,108,111.76Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,193.51a7.48,7.48,0,0,1,3.61-1c0-17.29.79-24.45,2.14-27.26s1.78-4.69,1.28-5.09-2.78,4.15-4.48,4.5-2.55-.79-2.55-3.06a8.09,8.09,0,0,1-2.55,6c-1.71,1.63-4-.3-4.48.68s-.07,2.35,1.28,3.6,2.13,7.52,2.13,24.8a15.35,15.35,0,0,1,3.62-3.13",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,141.19c.25,3.25.3,6.62.31,10s-.06,6.82-.31,10.36c-.25-3.25-.3-6.61-.31-10S107.78,144.73,108,141.19Z",
    style: {
      fill: "#845EC2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.56,141.77c-.77,4.67-4.86,8.95-9.13,9.57s-7.11-2.67-6.34-7.33,4.86-8.95,9.13-9.57S83.33,137.1,82.56,141.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 141.24,
    cy: 104.54,
    rx: 11.86,
    ry: 5.38,
    transform: "translate(-23.18 166.54) rotate(-57.17)",
    style: {
      fill: "#ebebeb"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.07,326.24a1,1,0,0,1-.91-.59L293.73,282a1,1,0,0,1,.5-1.32,1,1,0,0,1,1.32.51L315,324.84a1,1,0,0,1-.91,1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.74,274.67a2.19,2.19,0,0,0-3,.59,1.86,1.86,0,0,0-.12,1.58l3.06,8.84a2.48,2.48,0,0,0,1.13,1.34,2.21,2.21,0,0,0,3.05-.58,1.89,1.89,0,0,0,.12-1.59L294.88,276A2.46,2.46,0,0,0,293.74,274.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.88,276a2.46,2.46,0,0,0-1.14-1.34,2.19,2.19,0,0,0-3,.59,1.86,1.86,0,0,0-.12,1.58l1.92,5.57,3.83-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.7,275.26a2.19,2.19,0,0,1,3-.59,2.46,2.46,0,0,1,1.14,1.34,1.88,1.88,0,0,1-.12,1.59,2.22,2.22,0,0,1-3.05.59,2.54,2.54,0,0,1-1.13-1.35A1.86,1.86,0,0,1,290.7,275.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,271.69l-7.27,4.19v3.76c0,2.06-.68,3.54-1.77,4.26l-.31.18a4.21,4.21,0,0,1-4-.46c-3.36-1.94-6.09-6.87-6.09-11v-3.76l16.24-9.37v3.76A14.29,14.29,0,0,0,295,271.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,271.69l-7.27,4.19v3.76c0,2.06-.68,3.54-1.77,4.26l15.93-9.19.31-.18c1.1-.72,1.78-2.2,1.78-4.27V266.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.21,285.4a6.2,6.2,0,0,1-3.08-.91c-3.7-2.13-6.59-7.35-6.59-11.89v-3.76a1,1,0,0,1,.5-.86l16.24-9.37a1,1,0,1,1,1,1.73l-15.74,9.08v3.18c0,3.76,2.56,8.41,5.59,10.16a3.28,3.28,0,0,0,3.06.43l.26-.15c.79-.52,1.27-1.77,1.27-3.4v-3.76a1,1,0,0,1,.5-.86l16.25-9.38a1,1,0,1,1,1,1.73l-15.75,9.09v3.18c0,2.34-.79,4.15-2.22,5.1l-.36.21A4.28,4.28,0,0,1,284.21,285.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.21,285.4a6.2,6.2,0,0,1-3.08-.91c-3.7-2.13-6.59-7.35-6.59-11.89v-3.76a1,1,0,0,1,.5-.86l16.24-9.37a1,1,0,1,1,1,1.73l-15.74,9.08v3.18c0,3.76,2.56,8.41,5.59,10.16a3.28,3.28,0,0,0,3.06.43l.26-.15c.79-.52,1.27-1.77,1.27-3.4v-3.76a1,1,0,0,1,.5-.86l16.25-9.38a1,1,0,1,1,1,1.73l-15.75,9.09v3.18c0,2.34-.79,4.15-2.22,5.1l-.36.21A4.28,4.28,0,0,1,284.21,285.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.78,326.18a6.53,6.53,0,0,1,3-5.11,2,2,0,0,1,2.16-.15h0l1.26.71-4.24,7.19-1.24-.71h0A2.06,2.06,0,0,1,309.78,326.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07,321.84a6.52,6.52,0,0,0-2.95,5.11c0,1.88,1.32,2.64,2.95,1.7a6.52,6.52,0,0,0,2.95-5.11C317,321.66,315.7,320.9,314.07,321.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.13,299.66a1.31,1.31,0,0,1-.39-.05,1.49,1.49,0,0,1-1.05-1.84l7.65-28a43,43,0,0,1,20.1-26.06l21.69-12.52a1.5,1.5,0,0,1,2.05.55,1.51,1.51,0,0,1-.55,2.05l-21.69,12.52a40,40,0,0,0-18.71,24.25l-7.65,28A1.49,1.49,0,0,1,318.13,299.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 420.12 427.81 384.94 366.88 349.76 305.95 384.94 366.88 420.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 424.79 366.88 420.12 427.81 384.94 427.81 389.61 366.88 424.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.95 384.94 305.95 389.61 366.88 424.79 366.88 420.12 305.95 384.94",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 376.09 366.88 410.74 411.56 384.94 411.56 350.29 366.88 376.09",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 376.09 366.88 410.74 322.19 384.94 322.19 350.29 366.88 376.09",
    style: {
      fill: "#263238"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "411.56 350.29 366.88 324.49 322.19 350.29 366.88 376.09 411.56 350.29"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 340.38 366.88 373.21 411.56 347.41 411.56 314.58 366.88 340.38",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.88 340.38 366.88 373.21 322.19 347.41 322.19 314.58 366.88 340.38",
    style: {
      fill: "#263238"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.65 347.68 322.65 350.02 366.88 375.56 366.88 373.21 322.65 347.68"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "411.1 347.68 411.1 350.02 366.88 375.56 366.88 373.21 411.1 347.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.67 176.51 439.49 208.74 413.46 308.79 362.81 338.03 342.5 363.83 286.69 331.6 307 305.81 357.64 276.57 383.67 176.51",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.5 363.83 362.81 338.03 413.46 308.79 439.49 208.74 446.42 212.74 419.97 314.42 366.88 345.07 342.51 376.04 342.5 363.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.69 331.6 286.69 343.81 342.5 376.04 342.5 363.83 286.69 331.6",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,201.5l-8.12-4.69h0l-52.54-30.33a1.81,1.81,0,0,0-2.8,1.17L349.1,268.86a6.88,6.88,0,0,1-2.8,3.67l-36.29,21a1.52,1.52,0,0,0-.9,1.25v9.38a1.53,1.53,0,0,0,.9,1.25l52.54,30.33a4.79,4.79,0,0,0,4.33,0l44.41-25.64a6.84,6.84,0,0,0,2.8-3.67l26.32-101.21A3.48,3.48,0,0,0,438.87,201.5Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,166.48l52.54,30.33a3.47,3.47,0,0,1,1.53,3.67L406,301.69a6.77,6.77,0,0,1-2.79,3.67l-36.29,20.95a4.79,4.79,0,0,1-4.33,0L310,296a1.32,1.32,0,0,1,0-2.5l36.29-21a6.88,6.88,0,0,0,2.8-3.67l26.31-101.21A1.81,1.81,0,0,1,378.21,166.48Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,166.48l52.54,30.33a3.47,3.47,0,0,1,1.53,3.67L406,301.69a6.77,6.77,0,0,1-2.79,3.67l-36.29,20.95a4.79,4.79,0,0,1-4.33,0L310,296a1.32,1.32,0,0,1,0-2.5l36.29-21a6.88,6.88,0,0,0,2.8-3.67l26.31-101.21A1.81,1.81,0,0,1,378.21,166.48Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.41,205.17,414.09,306.38a6.87,6.87,0,0,1-2.79,3.67l-44.42,25.64a4.79,4.79,0,0,1-4.33,0L310,305.36a1.54,1.54,0,0,1-.89-1.25v-9.38A1.52,1.52,0,0,0,310,296l52.54,30.33a4.73,4.73,0,0,0,4.33,0l36.29-20.95a6.84,6.84,0,0,0,2.8-3.67l26.31-101.21a3.47,3.47,0,0,0-1.44-3.61l8,4.63A3.48,3.48,0,0,1,440.41,205.17Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.41,205.17,414.09,306.38a6.22,6.22,0,0,1-1.13,2.13l-8.12-4.68a6.26,6.26,0,0,0,1.13-2.14l26.31-101.21a3.47,3.47,0,0,0-1.44-3.61l8,4.63A3.48,3.48,0,0,1,440.41,205.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,326.83a4.9,4.9,0,0,0,1.68-.29,4.68,4.68,0,0,1-1.68.3Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,271a6.3,6.3,0,0,1-1.67,1.54l-36.29,21a1.32,1.32,0,0,0,0,2.5l52.54,30.33a4.79,4.79,0,0,0,4.33,0l36.29-20.95a6.14,6.14,0,0,0,1.67-1.54Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,336.21v-9.38a4.38,4.38,0,0,1-2.17-.52L310,296a1.52,1.52,0,0,1-.89-1.25v9.38a1.54,1.54,0,0,0,.89,1.25l52.54,30.33A4.49,4.49,0,0,0,364.72,336.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.84,303.82h0a6.3,6.3,0,0,1-1.67,1.54l-36.29,20.95a4.37,4.37,0,0,1-2.16.52v9.38a4.48,4.48,0,0,0,2.16-.52l44.42-25.64a6.42,6.42,0,0,0,1.66-1.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.76,329.24a2.12,2.12,0,0,0-1.11-1.84l-52.54-30.33a3,3,0,0,0-3.71.71l-17.22,21.87a2.26,2.26,0,0,0-.49,1.37v9.38a2.12,2.12,0,0,0,1.11,1.85l52.54,30.33a3,3,0,0,0,3.71-.71L361.27,340a2.14,2.14,0,0,0,.49-1.38Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.77,338.62a2.21,2.21,0,0,1-.5,1.38l-15.18,19.28-2,2.59a2.86,2.86,0,0,1-1.55,1v-9.38a2.86,2.86,0,0,0,1.55-1l17.21-21.87a2.21,2.21,0,0,0,.5-1.37C361.77,329.71,361.76,337.9,361.77,338.62Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.51,353.46v9.38a2.88,2.88,0,0,1-2.17-.26L287.8,332.25a2.14,2.14,0,0,1-1.11-1.84V321a2.13,2.13,0,0,0,1.11,1.84l52.54,30.33A2.88,2.88,0,0,0,342.51,353.46Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.65,327.4l-52.54-30.33a3,3,0,0,0-3.71.71l-17.22,21.87a2.11,2.11,0,0,0,.62,3.22l52.54,30.33a3,3,0,0,0,3.71-.71l17.22-21.87A2.11,2.11,0,0,0,360.65,327.4Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,206.19,378.2,178l-3.7-2.13a3.15,3.15,0,0,0-4.39,1.27,43.16,43.16,0,0,0-4.8,19.69,3.21,3.21,0,0,0,1.59,2.79l53.69,31Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,206.19,378.2,178l-3.7-2.13a3.15,3.15,0,0,0-4.39,1.27,43.16,43.16,0,0,0-4.8,19.69,3.21,3.21,0,0,0,1.59,2.79l53.69,31Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,206.19l-1.41,5.44L369.19,179.1c.29-.65.6-1.29.92-1.92a3.16,3.16,0,0,1,4.39-1.27l3.7,2.14Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,177.19c-.32.63-.61,1.27-.9,1.91l56.34,32.52,1.41-5.43-2.34-1.35L378.2,178.05l-3.7-2.14a3.18,3.18,0,0,0-3.05-.08,3.12,3.12,0,0,0-1.34,1.35Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.1,177.19c-.32.63-.61,1.27-.9,1.91l56.34,32.52,1.41-5.43-2.34-1.35L378.2,178.05l-3.7-2.14a3.18,3.18,0,0,0-3.05-.08,3.12,3.12,0,0,0-1.34,1.35Z",
    style: {
      fill: "#fff",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,230.66,427,206.19l-3.7-2.14a3.17,3.17,0,0,0-4.4,1.27A43.18,43.18,0,0,0,414.06,225a3.18,3.18,0,0,0,1.58,2.79Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.59,230.66,427,206.19l-3.7-2.14a3.17,3.17,0,0,0-4.4,1.27A43.18,43.18,0,0,0,414.06,225a3.18,3.18,0,0,0,1.58,2.79Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.56,329.21c-4.81,2.46-9.13,1.55-16.58-1.3s-20.31-11.43-23.89-18.57a12.71,12.71,0,0,1,2.76-15.24c2.31-1.81,17.51-1.15,32.11,9.92S354.69,324.79,347.56,329.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Legs--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306,381.14c.85,1.35,2.32,2.23,5.86,1.76s8.4-2,11.66-5.71,4.21-6.45,4.85-11,.59-6,2-7.77,2.7-4.48,2.58-5.48a7.77,7.77,0,0,0-1.37-2.62,13.37,13.37,0,0,0-5.27,7.8c-1.49,5.54-3.7,13.06-7.26,17.15C314.07,380.9,306,381.14,306,381.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.74,361.71c.86-8.55-4.39-30.83-4.39-30.83L323.42,322s.59,5.43,1.3,12.72S327,345,327,345s2.84,3.82,2.69,6.28-2.46,8-3.87,12.31-2.33,7.6-5,11.7-14.06,6.84-13.31,2.61C308.44,372,310.85,368.67,311.74,361.71Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89,274.18l-4.84-1.43s-32.34,17.18-37.72,21c-3.71,2.6-4.82,7.91-4.55,15.29s4,35.16,4,35.16l41.71-52.1Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,345c.94,0,2,1.63,2.7,2.83s2.65,2.15,2.21,5.12-3.18,5.11-3.78,9.16-1,11-7.09,15.76-12.38,5-14.63,3.59a3,3,0,0,1-1.35-1.83,2.35,2.35,0,0,1,.43-1.88c.73-1.48,1.42-3,2.05-4.52a63.56,63.56,0,0,0,3.29-9.66c.48-2.14.63-4.13,1.18-4.45a8.46,8.46,0,0,1,4.47-1.28c2.35-.25,3.65-.14,4,.08s.28,1,.35,1.46a.35.35,0,0,0,.12.23.31.31,0,0,0,.29,0,2.26,2.26,0,0,0,.84-1.12c.31-.74.53-1.52.79-2.29a22.58,22.58,0,0,1,.91-2.08c.62-1.41,1.38-2.74,2-4.14.43-.93,1.08-2.22,1.39-3.07a1.81,1.81,0,0,0,.08-1.36Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,345c.94,0,2,1.63,2.7,2.83s2.65,2.15,2.21,5.12-3.18,5.11-3.78,9.16-1,11-7.09,15.76-12.38,5-14.63,3.59a3,3,0,0,1-1.35-1.83,2.35,2.35,0,0,1,.43-1.88c.73-1.48,1.42-3,2.05-4.52a63.56,63.56,0,0,0,3.29-9.66c.48-2.14.63-4.13,1.18-4.45a8.46,8.46,0,0,1,4.47-1.28c2.35-.25,3.65-.14,4,.08s.28,1,.35,1.46a.35.35,0,0,0,.12.23.31.31,0,0,0,.29,0,2.26,2.26,0,0,0,.84-1.12c.31-.74.53-1.52.79-2.29a22.58,22.58,0,0,1,.91-2.08c.62-1.41,1.38-2.74,2-4.14.43-.93,1.08-2.22,1.39-3.07a1.81,1.81,0,0,0,.08-1.36Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305,353.53s-6.09,13.7-9,18.08a49,49,0,0,1-10.44,12c-1,.82-2.86,2.53-3.67,3.16a1.5,1.5,0,0,0-.29,2.29c1.35,1.91,8.3,3.66,12.81,1.48s9.48-7,12.29-8.95c1.41-1,2.74-1.88,3.71-2.56s.9-1.08.82-2.21l.51-1.8c.81-3.73,6.6-11.79,6.6-11.79Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.85,371.68c5.3-9.95,15.28-35.71,19.22-46.92s4.68-14.45,11.59-19.61,23-16,23-16c-3.54-4.68-4.68-10.17-3.66-16.38l42.14,3.49s2.15,15.69-3.64,23.26-25,18.34-33.19,22.14c-6.43,3-13.8,6.86-13.8,6.86a48.48,48.48,0,0,1-6.16,17.87c-4.34,7.19-14.24,16.53-17.93,22.71Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.63,393.67a4,4,0,0,0,.86,3c.82,1.11,4.52,5.23,13.15,4.94s12.13-4.57,13.48-6,5-6.05,7.14-6.87c2.33-.91,5.12-2.42,5.88-3.82s0-4.41,0-4.41-11.83,11.68-20.08,13.79S275,396,271.63,393.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,374.56c.83.54.59,3,.53,4.52s1,3.46-1.12,5.8-5.83,2.58-8.77,5.77-7.44,9.08-15.61,9.58-13.82-3-14.95-5.58a3.12,3.12,0,0,1-.09-2.4c.3-.8.76-1,1.49-1.39,1.53-.86,3-1.77,4.5-2.74a68.37,68.37,0,0,0,8.63-6.5c1.7-1.58,3-3.24,3.7-3.2A9.07,9.07,0,0,1,294.8,380c2.2,1.18,3.27,2,3.44,2.45s-.3,1-.58,1.5l-1.13,1.87a1.22,1.22,0,0,0-.19.46.4.4,0,0,0,.19.43.62.62,0,0,0,.52-.1c2.41-1.33,4.37-3.33,6.47-5.1a23,23,0,0,1,3.71-2.72c.92-.55,1.88-1.26,2.81-1.81a4.42,4.42,0,0,0,1.52-1.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,374.56c.83.54.59,3,.53,4.52s1,3.46-1.12,5.8-5.83,2.58-8.77,5.77-7.44,9.08-15.61,9.58-13.82-3-14.95-5.58a3.12,3.12,0,0,1-.09-2.4c.3-.8.76-1,1.49-1.39,1.53-.86,3-1.77,4.5-2.74a68.37,68.37,0,0,0,8.63-6.5c1.7-1.58,3-3.24,3.7-3.2A9.07,9.07,0,0,1,294.8,380c2.2,1.18,3.27,2,3.44,2.45s-.3,1-.58,1.5l-1.13,1.87a1.22,1.22,0,0,0-.19.46.4.4,0,0,0,.19.43.62.62,0,0,0,.52-.1c2.41-1.33,4.37-3.33,6.47-5.1a23,23,0,0,1,3.71-2.72c.92-.55,1.88-1.26,2.81-1.81a4.42,4.42,0,0,0,1.52-1.46Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M351.56,246.36S339.88,262,335.63,267.61a20.78,20.78,0,0,1-3.9,4.22l5.38,7.61c1.82-2.69,22.61-20.52,25.75-23.3C359.44,248.86,351.56,246.36,351.56,246.36Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.79,196.31A2.41,2.41,0,0,1,348,194.5a6,6,0,0,1,.46-3.65,1.74,1.74,0,0,0,2.92,1.41,2.74,2.74,0,0,0,.3-3c-.43-1-1.15-1.86-1.52-2.88-.91-2.47.46-5.3,2.5-7s4.64-2.45,7.12-3.33c3-1.07,5.88-2.83,8.95-3.63a17,17,0,0,1,9.42.05c8,2.52,9,8.36,9,8.37l1.2.38a8.92,8.92,0,0,1,2.93,2.24c2.52,2.79,3.14,6.8,6.13,9.15a14.54,14.54,0,0,1,2.63,2.17,4.21,4.21,0,0,1,.43,4.38c-.47.94-1.32,1.79-1.23,2.83.12,1.51,2,2.08,3.1,3.15a3.69,3.69,0,0,1,.15,5c-.56.61-1.31,1-1.91,1.58a2.11,2.11,0,0,0-.71,2.21,2.45,2.45,0,0,0,.7.87,20.09,20.09,0,0,1,2.48,2.4,4.32,4.32,0,0,1,1,3.2,4,4,0,0,1-1.87,2.63,9.39,9.39,0,0,1-3.1,1.13c-1.2.25-2.67.67-2.88,1.87a4.64,4.64,0,0,0,.14,1.43,4.21,4.21,0,0,1-2.78,4.48c-2.41.8-5-.74-7.53-.43s-4.44,2.34-6.89,2.8a5.75,5.75,0,0,1-4.91-1.45,24.36,24.36,0,0,0-2-2.06c-4.27-3.16-9.33,1-13.84.78a4.1,4.1,0,0,1-3.4-1.82c-.91-1.57-.39-3.89-1.8-5s-3.77-.15-5.35-1.11a3,3,0,0,1-1.28-2.68,5.05,5.05,0,0,1,1.2-2.83c.67-.85,1.59-1.76,1.36-2.83-.29-1.32-2.05-1.61-3-2.56a3.15,3.15,0,0,1-.66-3.09,5.31,5.31,0,0,1,1.94-2.62c1.12-.86,2.66-1.8,2.46-3.21-.16-1.1-1.35-1.74-1.86-2.73a3,3,0,0,1,.31-2.93A5,5,0,0,1,350.79,196.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,219c-3.65.48-6.61,0-10.3,3.6s-13.39,15.79-13.39,15.79,3.63,10.81,15.54,10.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.33,264.75a52.67,52.67,0,0,1,.56-12.63c-5.92-6.34-4.24-12.58-.84-17.27A68.33,68.33,0,0,1,362.86,219c3.57-.22,11.19-.09,11.19-.09,1.46.28,11.67,2.44,17.91,6.05a11.56,11.56,0,0,1,2.25,7.16,39.36,39.36,0,0,1-1.72,11.57l-4.17,15.19s1.24,4.1,2.3,7.92c.85,3.05,3.07,10.05,2.75,15.8s-.81,17.6-10.49,24.4c-10.42,7.32-28.72,18.26-35.32,22.24,3.28-2.37,2.91-6.1,2.25-8.82-.94-3.94-4.19-7.24-7-9.13-5.55-3.8-14.14-6-17.45-8.54-8-6.11-11-10.22-16.07-9,5.2-4.36,22.14-14.72,34.89-21.19A61.49,61.49,0,0,1,347.33,264.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,244.68c-3.69-1.38-3.89,2.76-10.51,1.68-2.91-.47-2.25,3.77,1.88,6.32s14.34,7.67,21.86,6.75,11.37-5.2,6.37-5.05-7.91,1.29-12.82-2.09S361.22,245.88,358,244.68Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,289.37c-1.11,1.94-1.75,3.47-1.27,3.88,1.55,1.34,2,.41,4,.95s3.34-1.8,4.08-4,2.36-4.79,4.3-5.79,2.14.81-.45,4.1-.64,4.76-.31,4.82,1.64-1.8,6.17-4,6.24-7.47,6.55-8.49,5.77-8.27,5.77-8.28A316.64,316.64,0,0,0,315.34,289.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.58,270.18c-.37-1.37-.72-2.55-1-3.41-.48-1.74-1-3.54-1.43-5L381.1,260l-6.39,10.17-33.65,20s-6.83,15.05-6.85,15.64c4.39,3.43,7.57-.89,7.57-.89,2-.46,4.36-2.4,6.44-5.66s5.1-2.29,7.86-2.59,3.33-2.82,4.53-5,14.09-7,21.13-10.9C387.13,277.83,389,276.44,391.58,270.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.1,292.49c7.64-5.54,9.67-8.26,4.72-9.47S325,293.44,318.44,297.08h0c1.85,1.47,4,3.39,7,5.64a17.16,17.16,0,0,0,3.13,1.77C336.73,299.11,341.54,295.8,346.1,292.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.19,192.62a59.61,59.61,0,0,0-.84,7.9c-.6,10.42,2.56,13.27,4.2,14.14s4.93.7,7.23.55l-.19,7c-.81,1-1.14,2.71,2.74,3.24,4.75.65,10.29-2.13,11.52-3.93l.46-12.68s2.5,1.89,5.4-1.18c2-2.07,2.42-5.37,1.26-7.33-1.48-2.5-5.08-2.53-6,.4s-3,2.22-2.8-2.31c.05-1.39,1.39-9.13-4.14-12.11-2.39-1.28-6.12,2.11-8.93,1.61-1.57-.28-2.09-3.85-4.77-3.13S358,188.71,357.19,192.62Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.52,197.39a1.38,1.38,0,1,0,1.55-1.24A1.4,1.4,0,0,0,370.52,197.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.39,207.94a.75.75,0,1,0,.84-.67A.77.77,0,0,0,366.39,207.94Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.74,194.34l2.79-1.62a1.56,1.56,0,0,0-2.16-.63A1.7,1.7,0,0,0,358.74,194.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,194.19l2.47,2.08a1.54,1.54,0,0,0-.13-2.24A1.7,1.7,0,0,0,373,194.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.33,196a1.38,1.38,0,1,0,2.73.36,1.38,1.38,0,1,0-2.73-.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.02 196.15 364.91 205 360.61 202.56 367.02 196.15",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.78,215.21c3.38-.17,11.34-1.71,12.63-4.34a7,7,0,0,1-2.69,3.27c-2.2,1.6-10,3.15-10,3.15Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.73,271.83a28,28,0,0,1-4,2.36c-2.34,1.24-5.68,2.7-7.43,3.58s-3.23,1.38-3.79,2.74-3.11,7.3-3.43,9.13.6,1.76.6,1.76c-.41,1.27,0,2,1,1.93s1.87-1.63,1.87-1.63-.23,1.49.53,1.75,2.28-.08,3.54-2.64,3.4-6.23,4.37-7,3-1.51,3.18-.1-2.42,3-3.57,4.86-.71,3.55-.12,3.81,1.19-.5,2.1-1.36,5.52-3.53,7.38-5.36,2.49-5.22,3.16-6.2a75.16,75.16,0,0,1,7.11-6.92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.08,280.32a7,7,0,0,0-1.33,1,5,5,0,0,0-.91,1.34c-.47,1-.88,2-1.35,3.05-.92,2-1.87,4-2.95,6,.74-2.11,1.61-4.17,2.52-6.21.48-1,.89-2,1.46-3a5.49,5.49,0,0,1,1.07-1.34A6.35,6.35,0,0,1,323.08,280.32Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.72,279.54a5.51,5.51,0,0,0-1.81,2.71c-.41,1-.85,2.07-1.3,3.09-.91,2.05-1.85,4.08-2.92,6.06.73-2.13,1.59-4.19,2.48-6.25.46-1,.92-2,1.41-3a11.46,11.46,0,0,1,.84-1.48A3.32,3.32,0,0,1,319.72,279.54Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,289.92c-1.11,1-1.21,3.3-4.44,4.45-3,1.06-5.33,1.46-6.1,2.08a42.27,42.27,0,0,0-4.16,5.71c-1.08,1.7-2.17,2.57-3.28,2-1.21,1.4-2.74,2.39-4,2.12a1,1,0,0,1-.78-1.35,2.29,2.29,0,0,1-2.09.89c-1.3-.22-.6-2.08-.6-2.08a1,1,0,0,1-.76-1.12,42.2,42.2,0,0,1,1.16-5.1,2.61,2.61,0,0,1-1.26.46c-.84.11-.91-.59-.5-1.41a47.75,47.75,0,0,0,1.56-4.77c.37-1.25,1.61-1.89,2.89-2.64,1.45-.84,5.47-2.27,8-3.39,3.83-1.72,5.87-2.71,7.47-4l19.52-15.9s5-5.84,10.12-3.07,5.94,9.77,1.33,13.05C380.7,277.6,360.85,288.37,359,289.92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.18,294.2c-.46.8-.85,1.63-1.25,2.46l-1.16,2.49-1.14,2.51c-.18.42-.36.84-.51,1.27-.07.21-.14.43-.19.65s-.1.49.13.6c-.26-.06-.26-.4-.26-.61a5.36,5.36,0,0,1,.1-.7,12.12,12.12,0,0,1,.39-1.34c.3-.88.67-1.73,1-2.57s.79-1.68,1.26-2.48A14.26,14.26,0,0,1,345.18,294.2Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.78,292.64a3.47,3.47,0,0,0-1.17,1.18,7.32,7.32,0,0,0-.64,1.55c-.34,1.08-.73,2.16-1.11,3.23s-.79,2.14-1.22,3.2-.86,2.11-1.34,3.15c.29-1.11.64-2.19,1-3.28s.73-2.16,1.12-3.23.79-2.13,1.22-3.2a7.81,7.81,0,0,1,.79-1.55A3.38,3.38,0,0,1,341.78,292.64Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.45,291.7a7.19,7.19,0,0,0-1.45,2.86c-.3,1-.66,2.07-1,3.1-.72,2.06-1.48,4.11-2.37,6.1.54-2.12,1.21-4.19,1.92-6.25.36-1,.73-2.05,1.13-3.07A5.92,5.92,0,0,1,338.45,291.7Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.06,288.51c-.84.57-1.72,1.09-2.59,1.61l-1.29.79a2.35,2.35,0,0,0-1,1c-.4.87-.67,1.89-1.05,2.82s-.72,1.91-1.14,2.84c.22-1,.5-2,.78-3a26.36,26.36,0,0,1,1-2.92,2.71,2.71,0,0,1,1.18-1.12c.44-.27.89-.5,1.35-.73C339.21,289.36,340.13,288.92,341.06,288.51Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,224.93c5,2.11,7,4.81,5,12.83s-6.43,22.19-9.65,31.95c-1,3.11-1.54,5.16-6,7.33l-10-9.7,8.5-25.89S384.47,225.57,392,224.93Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.32,224.05c4.08,1.26,6.29,2.79,7.31,4.82s1.3,8.33,1.29,15.28.25,15.38.25,15.38-14.34,5.23-23.77-6.17c0,0,4.71-14.41,6.05-18.62S386,225.54,390.32,224.05Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M375,361.42a1,1,0,0,1-.91-.59l-19.43-43.61a1,1,0,0,1,1.82-.82L375.91,360a1,1,0,0,1-.91,1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.68,309.85a2.21,2.21,0,0,0-3.05.58,1.89,1.89,0,0,0-.12,1.59l3.06,8.84a2.5,2.5,0,0,0,1.14,1.34,2.2,2.2,0,0,0,3-.58,1.92,1.92,0,0,0,.13-1.59l-3.07-8.84A2.48,2.48,0,0,0,354.68,309.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.81,311.19a2.48,2.48,0,0,0-1.13-1.34,2.21,2.21,0,0,0-3.05.58,1.89,1.89,0,0,0-.12,1.59l1.92,5.57,3.83-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.63,310.43a2.21,2.21,0,0,1,3.05-.58,2.48,2.48,0,0,1,1.13,1.34,1.89,1.89,0,0,1-.12,1.59,2.22,2.22,0,0,1-3.05.59,2.54,2.54,0,0,1-1.13-1.35A1.89,1.89,0,0,1,351.63,310.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,306.87l-7.27,4.19v3.76c0,2.06-.68,3.54-1.77,4.26l-.31.18a4.21,4.21,0,0,1-4-.46c-3.36-1.94-6.09-6.87-6.09-11V304l16.24-9.37v3.76A14.29,14.29,0,0,0,355.92,306.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.92,306.87l-7.27,4.19v3.76c0,2.06-.68,3.54-1.77,4.26l15.93-9.19.31-.18c1.1-.72,1.78-2.2,1.78-4.27v-3.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.14,320.58a6.24,6.24,0,0,1-3.07-.91c-3.7-2.14-6.6-7.36-6.6-11.89V304a1,1,0,0,1,.5-.86l16.24-9.38a1,1,0,0,1,1,1.74l-15.74,9.08v3.18c0,3.76,2.56,8.41,5.59,10.16a3.31,3.31,0,0,0,3.06.43l.26-.15c.79-.53,1.27-1.77,1.27-3.4v-3.76a1,1,0,0,1,.5-.86l16.25-9.39a1,1,0,0,1,1,1.74l-15.75,9.09v3.18c0,2.34-.79,4.15-2.22,5.1l-.36.21A4.28,4.28,0,0,1,345.14,320.58Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.14,320.58a6.24,6.24,0,0,1-3.07-.91c-3.7-2.14-6.6-7.36-6.6-11.89V304a1,1,0,0,1,.5-.86l16.24-9.38a1,1,0,0,1,1,1.74l-15.74,9.08v3.18c0,3.76,2.56,8.41,5.59,10.16a3.31,3.31,0,0,0,3.06.43l.26-.15c.79-.53,1.27-1.77,1.27-3.4v-3.76a1,1,0,0,1,.5-.86l16.25-9.39a1,1,0,0,1,1,1.74l-15.75,9.09v3.18c0,2.34-.79,4.15-2.22,5.1l-.36.21A4.28,4.28,0,0,1,345.14,320.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.72,361.36a6.52,6.52,0,0,1,2.95-5.11,2,2,0,0,1,2.16-.15h0l1.26.71L372.85,364l-1.24-.71h0A2,2,0,0,1,370.72,361.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,357a6.54,6.54,0,0,0-2.95,5.12c0,1.88,1.32,2.64,2.95,1.7a6.52,6.52,0,0,0,2.95-5.11C378,356.84,376.63,356.07,375,357Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06,334.84a1.31,1.31,0,0,1-.39,0,1.49,1.49,0,0,1-1.05-1.84l7.65-28a43,43,0,0,1,20.1-26.06l21.69-12.52a1.5,1.5,0,0,1,2.05.55,1.51,1.51,0,0,1-.55,2.05l-21.69,12.51a40.09,40.09,0,0,0-18.71,24.26l-7.65,28A1.51,1.51,0,0,1,379.06,334.84Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.58,184.31c7.82,1.28,8.89,1.9,10.94,5.67,3.29,6,5.26,18.33,5.54,40.83.18,14.47,5.21,31.95,6.11,45.67,1.34,20.62,2,36.67,2,36.67A263.45,263.45,0,0,0,174.38,311Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150,393.74s-2.62-25-1.08-39.8c1.33-12.74,3.2-18.07,3.46-21,0,0,2.14-29.89,1.56-55.21-.27-12,.34-25.23,8.88-39.39l.3-.56c.76,4.64,7.91,7.65,14.29,8.36q9.23,1,23-3.65c2,12,4.36,34.88,6.72,59.82,1.15,12.19.95,22.45,1.16,30.28.27,10.63-.7,52.29-.7,52.29l0,1.76c.06,1.94.53,3.29,1.89,6.37a37.88,37.88,0,0,0,7,10.78c.92.92,7.22,6.08,8.06,7.19,2.73,3-2.66,4.89-6.72,4.48-4.29-.42-11-1.83-12.94-4.36-1.31-1.69-2.45-7.73-3.8-9.44-4.54-5.78-6.4-8.26-6.5-10.16-.17-3.41,1-4.8,1.32-6.75-.49-4-8.65-25.06-9.19-36.8-.26-5.6,1-15.52,1-15.52l-7.18-40.81c-1.59,11.48-4.62,37.33-5.72,45.56-1.51,11.33-7.1,30.51-10.63,45.56-1.33,5.66-2.29,8.6-2.62,12.29,0,0-.16,1.3-.16,1.32,0,1.67-1.55,18.55-2.08,22.33-1.12,7.89-8.39,9-9.71,2.65-1.13-5.38.34-23.76.3-25.81Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,393.74c-2.12,0-.88,7.64-1.52,12.53-.7,5.24-2.63,9-3.25,13.31-.7,4.9-.27,7,1.54,11.1,1.42,3.21,8.75,7.79,11.66,3.38s3.62-9.53,3.4-14.45c-.24-5.08-.49-8.8-.52-12.67,0-3.4,2.95-11.29.21-11.87l-.16,1.32c-1,1.8-10.45,2.73-11.49-.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194,395.59c-.52,2.48.33,9.19.33,9.19s1.14,2.28,5,3.7l1.39-9.42Z",
    style: {
      fill: "#263238"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.33 408.48 207.59 405.46 209.36 397.99 200.13 403.05 199.33 408.48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.3,386.57l0-1.75c1.15.51,3.95,9.56,7.54,15.72,3.27,5.62,9.48,8.6,11.55,11,2.76,3.24-2.25,7.7-10.59,6.21-4.13-.75-10.44-3.17-12.22-5.88s-2.52-7.79-4-9.78-4.8-4.23-5.58-6.53a12.67,12.67,0,0,1-.19-6.4c.58-2.14,1.06-4.71,1.79-4.5l.1,1.6c.59,1.11,2.63,2.36,6.82,2.45C204.53,388.78,206.45,388.41,207.3,386.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.56,352.49a87.25,87.25,0,0,1,.7-19.24l-6-40.14s-4.11,38.21-4.8,44.13S163.75,407,163.75,407c-5.63,3.34-12.87,2.28-17.57-.22,0-25.83.81-51.72,1.75-58.87a120.6,120.6,0,0,1,3.34-14.48s.6-37.69.57-52,1-23.88,3.77-30.32a91.28,91.28,0,0,1,7.5-13.41s2.09,7.05,18.65,7.07,18.4-4.18,18.4-4.18,4.85,16.94,6.47,42.53c1.3,20.63,1.6,30,2,39.2.33,7.84.54,16.89.72,32.71.14,11.94,1.83,38.21,1.83,38.21s-8.09,4.24-21.44-.6C189.73,392.69,186.39,362.8,185.56,352.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,293.11l3.28-24.27a20.75,20.75,0,0,0,12.67-6.13s-1.85,5.88-9.63,9.18l-4.39,21.29,3.21,34.18Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--top--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.48,209.19c1.21-2.41,5.16-1.12,8.32,2.77s3.81,6.83,2.89,9.11-3.77,3.9-5.48,2.93S223.93,216.15,225.48,209.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.48,209.19c1.21-2.41,5.16-1.12,8.32,2.77s3.81,6.83,2.89,9.11-3.77,3.9-5.48,2.93S223.93,216.15,225.48,209.19Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,204.18a18.8,18.8,0,0,0,.77-2.88c1-4.71,4-8.61,7.09-12.13q.79-.9,1.62-1.8a10.4,10.4,0,0,0,.76-.88c.21-.31.4-.55.84-.41a1.38,1.38,0,0,1,.7.67,4,4,0,0,1,.08,3.18,19.91,19.91,0,0,1-1.52,2.89c-.42.73.53.61,1,.49,2.15-.6,4.57-3.2,6.07-4.8a28.46,28.46,0,0,1,2.93-3.18,4.42,4.42,0,0,1,2.44-1c.6,0,1.17.14,1.13.9a3,3,0,0,1-.52,1.3,3.28,3.28,0,0,0-.62,2.61,7.45,7.45,0,0,1,.49,1.88,22.61,22.61,0,0,1-.54,2.41,20.06,20.06,0,0,0,.27,2.1,6.1,6.1,0,0,1-.93,2.35,19.87,19.87,0,0,1-3,4.25,38.53,38.53,0,0,1-6,5.14,10.54,10.54,0,0,0-3.2,3,22.85,22.85,0,0,0-1.71,4.08c-.6,1.76-1.16,3.52-1.76,5.27-6.44,19-8.58,19.82-11.48,22.41-1.75,1.56-6.38,2.66-11.61-4.3-5.8-7.71-16.31-27.16-16.31-27.16l-1-24a22.7,22.7,0,0,1,7.11,1.85c3.34,1.77,4.72,4.56,6.31,8,3.31,7,11.83,25.3,11.83,25.3S226.85,206.61,228,204.18Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.38,185.84c5.38,1,7.55,1.41,10.23,3.94S209,199,211.32,203.9s7.75,16.25,7.75,16.25l6.41-11a12.6,12.6,0,0,0,3.78,9c4.1,4.06,6.62,3.58,7.43,2.85-2,5.31-8.59,19.07-12.83,21.37s-7.58,2.12-12.54-3.27S193.38,210,193.38,210Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,196a14.36,14.36,0,0,1-2.79,7.52,8.51,8.51,0,0,0,2.7-3.41C238.23,198,238,197,237.56,196Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,186l-7.2,1.39c-5.18,1.27-8.12,3-8.65,7.58a35.9,35.9,0,0,0,.27,15c1.64,6.45,6,22.27,6,22.27s-5.66,14.22-8.34,21.45c18.41,12,41.12,7.26,48.76,0-.65-6.87-3.08-13.27-3.63-19.4,0,0,.4-9.56,1.16-13.71,5.82-6.36,5.08-12.44,2.47-17.34-4.83-9-12.11-17-14.46-17Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.49,186l-7.2,1.39c-5.18,1.27-8.12,3-8.65,7.58a35.9,35.9,0,0,0,.27,15c1.64,6.45,6,22.27,6,22.27s-5.66,14.22-8.34,21.45c18.41,12,41.12,7.26,48.76,0-.65-6.87-3.08-13.27-3.63-19.4,0,0,.4-9.56,1.16-13.71,5.82-6.36,5.08-12.44,2.47-17.34-4.83-9-12.11-17-14.46-17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.74,183.55a18.48,18.48,0,0,1,8.31,4.93,24,24,0,0,1,5.85,9s-5.89-7.27-10.37-9.64a15.45,15.45,0,0,0-3.79-1.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,186.41s1.09,4.71,10.88,28c1.46,11.46-3.56,46.12-4.34,66.65-.57,15-2,36.49-2,36.49a48.49,48.49,0,0,1-13.83.26c-7.63-.94-10.62-2.07-14.94-4.89,0,0,2.73-37.71,4.57-52.31a117.06,117.06,0,0,1,6.8-26.15l-4.69-39s-.45-3.58,5.06-6.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,206.76c0-.71-.06-2.24-.19-4.18-.6-9.47-.87-18,2.32-18.71l.29,1.3c-2.34.5-1.57,12.72-1.27,17.32.12,2,.22,3.54.19,4.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.72,238.41h-.12l0-.93a6.12,6.12,0,0,0,3.06-1.14,11.78,11.78,0,0,1-2.55-2.31c-1.5-1.95-4.8-15.85-3.78-19.09.85-2.71,3.52-8.7,5.89-8.8h.07c2.37,0,5.48,5.66,6.55,8.27,1.29,3.14-.81,17.27-2.15,19.34a11.12,11.12,0,0,1-2.34,2.51,5.93,5.93,0,0,0,3.15.88l.12.93a7.25,7.25,0,0,1-4.09-1.19A7.45,7.45,0,0,1,167.72,238.41Zm2.61-31.34h0c-1.39.06-3.9,4.51-5,8.15-.93,3,2.24,16.43,3.63,18.24a10.91,10.91,0,0,0,2.63,2.29,11,11,0,0,0,2.43-2.51c1.24-1.92,3.25-15.59,2.07-18.48C174.58,211.26,171.74,207.07,170.33,207.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,237.54a1.37,1.37,0,1,1-1.43-1.31A1.37,1.37,0,0,1,177,237.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,237.88a1.37,1.37,0,1,1-1.43-1.31A1.37,1.37,0,0,1,169,237.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,220.54l-.79-.06a.3.3,0,0,1-.28-.33,15.6,15.6,0,0,0-.25-5.3c-1.38-3.37-4.24-7.6-5.49-7.54s-3.73,4.51-4.83,8a16.09,16.09,0,0,0,.21,5.3.32.32,0,0,1-.25.36l-.78.12a.31.31,0,0,1-.35-.27c-.43-2.9-.49-4.9-.16-5.93.58-1.86,3.33-8.85,6.1-9s6.11,6.6,6.85,8.41c.41,1,.53,3,.34,5.92A.31.31,0,0,1,177.12,220.54Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.31,154.73a1.62,1.62,0,0,1-2.83.45c-.79-1.27.28-2.86.7-4.31.68-2.34-1-5.3-3.29-5.23a3,3,0,0,0,1.16-3.36,4.6,4.6,0,0,0-2.4-2.76,6.16,6.16,0,0,0-5.82.14,3.82,3.82,0,0,0,.26-3.77A3.4,3.4,0,0,0,190,134a2,2,0,0,1,0,2.91,3,3,0,0,1-3.05.32,18.76,18.76,0,0,1-2.81-1.6,11.45,11.45,0,0,0-9.35-1c-3.17,1.06-6.18,3.66-6.86,7.25a12.53,12.53,0,0,0-6.7,1.4,5.88,5.88,0,0,0-2.55,2.26c-.86,1.56-.61,3.52-.29,5.3a7,7,0,0,0-4.11,5.65,9.09,9.09,0,0,0,2.15,6.89,15.21,15.21,0,0,1,1.64,2,2.74,2.74,0,0,1,.32,2.49c-.58,1.25-2.27,1.37-3.51.88a2.7,2.7,0,0,0,1.74,2.86,7,7,0,0,0,3.46.17,4.68,4.68,0,0,0,.28,5.86,3.24,3.24,0,0,0,4.86.09c-1.18,1.82.2,5.1,2.9,4.27a1.23,1.23,0,0,1-.74-1.36,1.21,1.21,0,0,1,1.21-1,3.55,3.55,0,0,1,1.52.8,2.41,2.41,0,0,0,3.13-.27,10.48,10.48,0,0,0,5.54,3.36,15.36,15.36,0,0,0,6.51.09,11.9,11.9,0,0,0,6.07-2.81c2.45-2.33,3.29-5.92,3.62-9.32a20,20,0,0,1,.49-3.46c.65-2.28,2-3.16,4.22-3.53a7.43,7.43,0,0,0,4.42-2.6A7.77,7.77,0,0,0,205.31,154.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17,146c1.84.66,5.51,5.55,5.15,19.49-.29,11.3-2.25,13-5.09,14.5-1.76,1-5.92,1.13-8.48.89v5.63s6.4,6.53-2.17,7.45-14.22-6.75-14.22-6.75l.22-13.87s-2.24,2.23-5.49-.37a6.9,6.9,0,0,1-1-9.42,3.92,3.92,0,0,1,4.47-1.15,3.53,3.53,0,0,1,1.45,1c.34.42.58.92.94,1.33a2,2,0,0,0,3.2-.22,5.14,5.14,0,0,0,.82-1.87c.86-3.4,0-7.18,1.49-10.37a3.69,3.69,0,0,1,2.91-2.35,10.68,10.68,0,0,1,4.43.66c2.46.66,5.38,1,7.71,0A5.5,5.5,0,0,0,194.17,146Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.93,170.86l5,1.8a2.59,2.59,0,0,1-3.32,1.79A2.9,2.9,0,0,1,183.93,170.86Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.56,172a2,2,0,0,0-.74.09,2.82,2.82,0,0,0,1.77,2.37,2.41,2.41,0,0,0,1.18.11.69.69,0,0,0,0-.13A2.33,2.33,0,0,0,184.56,172Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.46,157.18l-3.37-.93a1.67,1.67,0,0,1,2.09-1.25A1.84,1.84,0,0,1,197.46,157.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.57,156.44l-3.16,1.5a1.68,1.68,0,0,1,.76-2.32A1.85,1.85,0,0,1,184.57,156.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "188.8 159.95 189.32 168.95 194.46 167.88 188.8 159.95",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75,180.87c-6.77-.79-12.45-3.46-13.77-6.35,0,0-.1,2.83,3.24,4.92,3.49,2.18,10.53,3.55,10.53,3.55Z",
    style: {
      fill: "#874c4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,161.29a1.62,1.62,0,0,0,1.31,1.81,1.52,1.52,0,0,0,1.78-1.26,1.62,1.62,0,0,0-1.31-1.81A1.52,1.52,0,0,0,193.87,161.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.67,161.69A1.62,1.62,0,0,0,184,163.5a1.5,1.5,0,0,0,1.78-1.25,1.61,1.61,0,0,0-1.31-1.81A1.52,1.52,0,0,0,182.67,161.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93,157.94l-10.76,4.32a4.09,4.09,0,0,1,2,1.31l8.83-3.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.73,156.69l-.68-.05a19.56,19.56,0,0,0-6.77.45c-2.16.75-2.92,1.52-4.11,1.57s-2.09-.68-4.39-1.27a22.2,22.2,0,0,0-7.23,0l-.73.11a1.21,1.21,0,0,0-.8,1.25,2.63,2.63,0,0,0,.69,1.4,1.66,1.66,0,0,1,.24.56,24.09,24.09,0,0,0,.87,3.9,4.86,4.86,0,0,0,.92,1.38c.15.14.3.27.47.4a2.61,2.61,0,0,0,.28.17,3.55,3.55,0,0,0,.81.37l.13,0,.22.06.22,0a4.17,4.17,0,0,0,.72.09l.31,0h.38a5.12,5.12,0,0,0,4.95-3.09c.75-1.51.56-3.61,1.93-3.65h.25c1,.21.88,2.14,1.52,3.51a5.61,5.61,0,0,0,1,1.48,2.61,2.61,0,0,0,.24.23l.12.11.13.1.12.08.12.09.11.06.07,0a4,4,0,0,0,1.18.45l.11,0a6.42,6.42,0,0,0,1.44.1,4.37,4.37,0,0,0,4.2-2.87,27.38,27.38,0,0,0,.86-4,1.25,1.25,0,0,1,.25-.53,2.84,2.84,0,0,0,.63-1.47C202.5,157.29,202.1,156.73,201.73,156.69Zm-14.26,6.05a4.59,4.59,0,0,1-1,2.11h0a4.22,4.22,0,0,1-3.24,1.3,3.44,3.44,0,0,1-3.1-1.41.71.71,0,0,1-.1-.14.6.6,0,0,1-.09-.15l-.08-.13-.06-.12a.93.93,0,0,1,0-.1.36.36,0,0,1,0-.09l-.06-.15h0c-.06-.15-.12-.29-.16-.43h0a2.58,2.58,0,0,1-.08-.26c0-.15-.07-.29-.1-.41s0-.06,0-.08v-.08c-.23-1-.5-3.07,0-3.54s1.86-1,4.07-.86h.24c.34,0,.68.08,1,.14l.39.09a8.11,8.11,0,0,1,1,.29l.3.12a2.52,2.52,0,0,1,.33.14l.07,0,.11.06a2,2,0,0,1,.66.52C187.86,160.23,187.72,161.58,187.47,162.74Zm12.89-.88a4.68,4.68,0,0,1-2.09,3.4,3.92,3.92,0,0,1-1.65.42,3.44,3.44,0,0,1-3.3-1.44v0l-.06-.09-.07-.11,0-.06a.8.8,0,0,1-.08-.16l-.09-.19a.36.36,0,0,1,0-.09l0-.05,0-.08a.14.14,0,0,1,0-.06,4.74,4.74,0,0,1-.21-.77,5,5,0,0,1,.07-3.14c.42-.65,2.05-1.41,3.62-1.66a10,10,0,0,1,1-.12h.89l.28,0a3.92,3.92,0,0,1,.51.07l.12,0h0l.08,0,.12,0,.15,0,.24.09,0,0a2.09,2.09,0,0,1,.55.33C200.85,158.75,200.58,160.81,200.36,161.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84,151.69a19.38,19.38,0,0,1-5.51,2.07,27.57,27.57,0,0,0-4.5,1.28,5.12,5.12,0,0,0-3.07,3.32,2.9,2.9,0,0,0,2.19,3.52,4.33,4.33,0,0,1-3.07.1,8.68,8.68,0,0,1-5-3.54c-2.55-4.21.24-9.35,3.6-12.12a19.63,19.63,0,0,1,14.19-4.47c2.24.25,4.37,1.78,4.49,4.14C194.3,148.61,193.52,150,190.84,151.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42,182.62c-.75.29-1.74,1.72-3.47,3a25.8,25.8,0,0,1-5.08,2.58s3.87,8.9,5.57,11c1.32,1.63,9.42,7.66,9.42,7.66s-2.17,8.17-2.25,10.85,5.17,12.87,5.75,18.08c0,0,1.65-16.38.88-22.26-1.35-10.23-8.12-20.73-9.31-23.86A29.37,29.37,0,0,1,169.42,182.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.61 222.72 185.36 234.45 174.55 280.01 175.29 280.8 206.91 268.99 219.35 223.51 218.61 222.72",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.1 235.24 175.29 280.8 174.55 280.01 185.36 234.45 186.1 235.24",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.35 223.51 186.1 235.24 175.29 280.8 206.91 268.99 219.35 223.51",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M209.34,231.61l.27-1.32c.15-.73-1.8-.35-4.36.86l-6,1.82c-2.56,1.2-5,2.1-5.13,2.83l-.27,1.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,225.61c.1-.45-.66-.36-1.72-.08l-1.92.65s.78-1.92-3.75-.69c-5,1.35-5.09,3.84-5.09,3.84a21.48,21.48,0,0,1-2.4.87c-1.65.54-1.84.86-2,1.33l-.25.84,16.95-6S211.22,226.07,211.31,225.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.53,228.16c-1.57.71-2.22,1.06-2.45,2.19-.27,1.29-.33,1.83-.33,1.83l-8.82,3.48s.47-1.9.59-2.53-1.05-.64-2.58.06l.37-1.58,13.72-5.1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,231.64s.13-.6.28-1.33-1.8-.35-4.36.86l-6,1.82c-2.56,1.2-5,2.1-5.13,2.84l-.28,1.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,261c1.79.73,2.93.06,4.25-2.25s3.95-10.81-.35-12.32c-4.17.67-6.44,5.63-6.37,8.94A8.88,8.88,0,0,0,166.65,261Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.65,261c1.79.73,2.93.06,4.25-2.25s3.95-10.81-.35-12.32c-4.17.67-6.44,5.63-6.37,8.94A8.88,8.88,0,0,0,166.65,261Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.59,248.68c-4-2.29-5.65-2.72-4.92-8.85,2-16.73,6.54-31.08,7.8-37.29,1.94-9.51,7.29-12.35,12.65-13.07,6.59,5,5.55,17.75,2.22,26.95l-5.86,20.15c5.51,3.31,13.21,7.67,16.58,9.22,4.21,1.93,7.18,2.25,8.88,1.22a23.91,23.91,0,0,1,3-1.7,5.44,5.44,0,0,1,1.93-.5l-1,4.06a2,2,0,0,0,.31,1.61A4.18,4.18,0,0,0,184,251a8.19,8.19,0,0,0,2,0,25.59,25.59,0,0,0,7-1.79c2.13-.89,4.13-2,6.53-2,.57,0,1.27.21,1.4.77s-.39,1-.76,1.41c-1,1.15-1.27,2.7-2.11,4-.39.58-1,1-1.38,1.59-.54.72-.82,1.6-1.4,2.29a6.46,6.46,0,0,1-1.42,1.18L191.55,260a12.6,12.6,0,0,1-2.06,1.23,10.67,10.67,0,0,1-2.51.66,24.3,24.3,0,0,1-7.8-.1,71.73,71.73,0,0,1-7.58-2.14C165.44,257.83,144.71,251.06,140.59,248.68Z",
    style: {
      fill: "#9e6767"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.59,189.24c-4.29.7-8.18,1.36-10.87,5.72s-4.46,13.13-7.07,24.35-3.8,21-3.86,23.87,1.07,4.36,3.86,6.18,28.47,11.78,28.47,11.78-1.8-.88-1.15-6.36c.7-6,3-8,4.58-8.37l-17.2-9.61,7.52-26.16S164.54,195,156.59,189.24Z",
    style: {
      fill: "#e6e6e6"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.74,110.66l-7,4,2.78,6.25a.64.64,0,0,0,.27.29l2.4,1.39a.64.64,0,0,0,.94-.37l3-10.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.74,110.66l-7,4,2.78,6.25a.64.64,0,0,0,.27.29l2.4,1.39a.64.64,0,0,0,.94-.37l3-10.22Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16,116.1l2.78,6.25a.64.64,0,0,0,1.2-.08l3-10.22Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.55,71.33,165.18,86.56a1.32,1.32,0,0,0-.61,1v32.72a1.34,1.34,0,0,0,.61,1l2.17,1.22a1.36,1.36,0,0,0,1.21,0l26.37-15.22a1.35,1.35,0,0,0,.61-1V73.59a1.32,1.32,0,0,0-.61-1l-2.17-1.21A1.36,1.36,0,0,0,191.55,71.33Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,73.48c-.05-.31-.29-.42-.6-.25L168.57,88.46a1.24,1.24,0,0,0-.43.45L164.76,87a1.24,1.24,0,0,1,.42-.43l26.37-15.23a1.36,1.36,0,0,1,1.21,0l2.17,1.21A1.32,1.32,0,0,1,195.53,73.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,122.23V89.51a1.34,1.34,0,0,1,.6-1.05l26.37-15.22c.34-.2.61,0,.61.35v32.72a1.35,1.35,0,0,1-.61,1l-26.37,15.22C168.23,122.77,168,122.62,168,122.23Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,122.58a1.39,1.39,0,0,1-1.21,0l-2.17-1.22a1.34,1.34,0,0,1-.61-1V87.6a1.19,1.19,0,0,1,.2-.61l3.37,1.92a1.23,1.23,0,0,0-.18.6v32.72C168,122.58,168.21,122.79,168.56,122.58Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--check-list--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-22",
    d: "M190.22,84a2.16,2.16,0,0,0-2.82,1.15l-8.13,19.34-1.93-1.88a2.15,2.15,0,0,0-3,3.08l4.2,4.08a2.13,2.13,0,0,0,1.5.61,2,2,0,0,0,.42-.05,2.17,2.17,0,0,0,1.56-1.27l9.35-22.24A2.16,2.16,0,0,0,190.22,84Z",
    style: {
      fill: "#fff"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRegister);
export default __webpack_public_path__ + "static/media/Patient_register.5c0a5a8dc760124588b1224b72fc8979.svg";
export { ForwardRef as ReactComponent };